import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import classes from "./WeeklyTimingTabs.module.css";
import globalClasses from "../../../commoncomponents/css/Global.module.css";
import SelectField from "../../../commoncomponents/dropdown/SelectField";
import InputField from "../../../commoncomponents/input/InputField";
import FormControlLabel from "@mui/material/FormControlLabel";
import { TIMINGSLOTDURATION } from "./ClinicianScheduleTimingDummyData";
import ButtonComponent from "../../../commoncomponents/buttons/ButtonComponent";
import TimeComponent from "../../../commoncomponents/input/TimeComponent";
import CommonCard from "../../../commoncomponents/layout/card/CommonCard";
import { getDateFromHours } from "../../../../util/GenralUtils";
import CommonLayout from "../../../commoncomponents/layout/CommonLayout";
import { setSnackbar } from "../../../commoncomponents/alert/SnackbarAction";
import {
  getRequest,
  postAxios,
  singoutHandler,
} from "../../../../api/AxiosAPICall";
import {
  CircularProgress,
  Collapse,
  IconButton,
  MenuItem,
  Stack,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  Typography,
  Box,
  Grid,
  Checkbox,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  ExpandCircleDownOutlined as ExpandCircleDownOutlinedIcon,
  DeleteForeverOutlined as DeleteForeverOutlinedIcon,
} from "@mui/icons-material";
import {
  useFormik,
  ErrorMessage,
  FieldArray,
  FormikProvider,
  getIn,
} from "formik";
import * as Yup from "yup";
import moment from "moment";
import { useDispatch } from "react-redux";
import { useNavigate, useNavigationType } from "react-router-dom";
import { nanoid } from "nanoid";

moment.suppressDeprecationWarnings = true;

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#E2F1FF",
    "&::before": {
      border: "1px solid #b1b1b1",
    },
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#E2F1FF",
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    border: "1px solid #b1b1b1",
    fontSize: 11,
    maxWidth: "250px",
  },
}));

const HPWeeklyTimingTabs = () => {
  const [clinicType, setClinicType] = useState([]);
  const [clinicLocation, setClinicLocation] = useState([]);
  const [open, setOpen] = useState(false);
  const isMounted = useRef<any>();
  const [isExpanded, setIsExpanded] = useState("");
  const [appointmentCrud, setAppointmentCrud] = useState(false);
  const dispatch = useDispatch();
  let history = useNavigate();
  let navType = useNavigationType();
  let jwtToken: any;

  if (localStorage.getItem("token") != null) {
    jwtToken = localStorage.getItem("token");
  }

  const fetchClinicType = useCallback(async () => {
    const response = await getRequest("userClinicTypes", {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    if (response.toString() === "ERROR") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cellmaflex has encounter an issue. Please contact administrator.",
          "top",
          "center"
        )
      );
    } else if (response.toString() !== "" && typeof response !== "object") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          response.toString(),
          "top",
          "center"
        )
      );
      singoutHandler(jwtToken);
      localStorage.removeItem("token");
      history("/signin");
    } else {
      setClinicType(response?.data);
    }
  }, [dispatch, history, jwtToken]);

  const fetchClinicLocation = useCallback(
    async (clinicTypeEliId: any) => {
      const response = await getRequest("userClinicTypeLocations", {
        params: {
          clinicTypeEliId: clinicTypeEliId,
        },
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
        singoutHandler(jwtToken);
        localStorage.removeItem("token");
        history("/signin");
      } else {
        setClinicLocation(response?.data);
      }
    },
    [dispatch, history, jwtToken]
  );

  useEffect(() => {
    return () => {
      if (navType === "POP") {
        history("/unauthenticatedUser");
      }
    };
  }, [navType, history]); // Empty dependency array means this effect runs only on unmount

  useEffect(() => {
    isMounted.current = true;

    fetchClinicType();

    return () => {
      isMounted.current = false;
      setClinicType([]);
      setClinicLocation([]);
    };
    // eslint-disable-next-line
  }, []);

  //This function used to set day values for Week
  const setDayTab = (formik: any, value: any, day: string, index: any) => {
    value?.forEach((element: any, weekIndex: any) => {

      const dayId = element.id || nanoid();

      // Set the unique ID in the formik field value
      formik.setFieldValue(
        `hpScheduleJsons[${index}].${day}[${weekIndex}].dayId`,
        dayId
      );

      if (element.padId !== "" && element.padId !== null && element.padId > 0) {
        formik.setFieldValue(
          `hpScheduleJsons[${index}].${day}[${weekIndex}].padid`,
          element?.padId
        );
      }
      if (element.panId !== "" && element.panId !== null && element.panId > 0) {
        formik.setFieldValue(
          `hpScheduleJsons[${index}].${day}[${weekIndex}].panid`,
          element?.panId
        );
      }

      formik.setFieldValue(
        `hpScheduleJsons[${index}].${day}[${weekIndex}].noAppointments`,
        element.numberOfAppointment
      );
      formik.setFieldValue(
        `hpScheduleJsons[${index}].${day}[${weekIndex}].timingSlotDuration`,
        element.appointmentDuration
      );

      if (
        element.startTime === null ||
        element.startTime === "" ||
        element.startTime === "00:00:00"
      ) {
        formik.setFieldValue(
          `hpScheduleJsons[${index}].${day}[${weekIndex}].startTime`,
          null
        );
      } else {
        formik.setFieldValue(
          `hpScheduleJsons[${index}].${day}[${weekIndex}].startTime`,
          getDateFromHours(element.startTime)
        );
      }

      if (
        element.endTime === null ||
        element.endTime === "" ||
        element.endTime === "00:00:00"
      ) {
        formik.setFieldValue(
          `hpScheduleJsons[${index}].${day}[${weekIndex}].endTime`,
          null
        );
      } else {
        formik.setFieldValue(
          `hpScheduleJsons[${index}].${day}[${weekIndex}].endTime`,
          getDateFromHours(element.endTime)
        );
      }

      if (
        (element.numberOfAppointment === "" ||
          element.numberOfAppointment === null) &&
        (element.appointmentDuration === "" ||
          element.appointmentDuration === null) &&
        (element.startTime === null || element.startTime === "") &&
        (element.endTime === null || element.endTime === "")
      ) {
        formik.setFieldValue(
          `hpScheduleJsons[${index}].${day}[0].markAsLeave`,
          true
        );
      }
    });
  };

  const fetchestablishmentProfessionalJson = useCallback(async () => {
    setOpen(true);
    const response = await getRequest(
      "establishmentProfessionals/appointmentSchedule",
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );
    if (response.toString() === "ERROR") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cellmaflex has encounter an issue. Please contact administrator.",
          "top",
          "center"
        )
      );
    } else if (response.toString() !== "" && typeof response !== "object") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          response.toString(),
          "top",
          "center"
        )
      );
      singoutHandler(jwtToken);
      localStorage.removeItem("token");
      history("/signin");
    } else {
      if (
        response?.data !== undefined &&
        response?.data !== null &&
        response?.data !== ""
      ) {
        response?.data?.hpScheduleJsons?.forEach((element: any, index: any) => {
          const uniqueId = nanoid();

          formik.setFieldValue(
            `hpScheduleJsons[${index}].hpScJsonId`,
            uniqueId
          );

          formik.setFieldValue(
            `hpScheduleJsons[${index}].padid`,
            element.padId ? element.padId : ""
          );

          formik.setFieldValue(
            `hpScheduleJsons[${index}].clinicTypeId`,
            element.clinicTypeId
          );
          formik.setFieldValue(
            `hpScheduleJsons[${index}].clinicType`,
            element.clinicTypeText
          );

          formik.setFieldValue(
            `hpScheduleJsons[${index}].clinicLocationsId`,
            element.clinicLocationId
          );
          formik.setFieldValue(
            `hpScheduleJsons[${index}].clinicLocations`,
            element.clinicLocationText
          );

          formik.setFieldValue(
            `hpScheduleJsons[${index}].timingSlotDuration`,
            element.appointmentDuration
          );
          formik.setFieldValue(
            `hpScheduleJsons[${index}].noAppointments`,
            element.numberOfAppointment
          );

          if (element.startTime === null || element.startTime === "") {
            formik.setFieldValue(`hpScheduleJsons[${index}].startTime`, null);
          } else {
            formik.setFieldValue(
              `hpScheduleJsons[${index}].startTime`,
              getDateFromHours(element?.startTime)
            );
          }
          if (element.endTime === null || element.endTime === "") {
            formik.setFieldValue(`hpScheduleJsons[${index}].endTime`, null);
          } else {
            formik.setFieldValue(
              `hpScheduleJsons[${index}].endTime`,
              getDateFromHours(element.endTime)
            );
          }
          setDayTab(formik, element.monday, "monday", index);
          if (
            element.monday !== undefined &&
            element.monday !== null &&
            element.monday !== ""
          ) {
            setDayTab(formik, element.monday, "monday", index);
          }
          if (
            element.tuesday !== undefined &&
            element.tuesday !== null &&
            element.tuesday !== ""
          ) {
            setDayTab(formik, element.tuesday, "tuesday", index);
          }

          if (
            element.wednesday !== undefined &&
            element.wednesday !== null &&
            element.wednesday !== ""
          ) {
            setDayTab(formik, element.wednesday, "wednesday", index);
          }

          if (
            element.thursday !== undefined &&
            element.thursday !== null &&
            element.thursday !== ""
          ) {
            setDayTab(formik, element.thursday, "thursday", index);
          }

          if (
            element.friday !== undefined &&
            element.friday !== null &&
            element.friday !== ""
          ) {
            setDayTab(formik, element.friday, "friday", index);
          }

          if (
            element.saturday !== undefined &&
            element.saturday !== null &&
            element.saturday !== ""
          ) {
            setDayTab(formik, element.saturday, "saturday", index);
          }

          if (
            element.sunday !== undefined &&
            element.sunday !== null &&
            element.sunday !== ""
          ) {
            setDayTab(formik, element.sunday, "sunday", index);
          }
        });
        setAppointmentCrud(false);
      }
    }
    setOpen(false);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    isMounted.current = true;
    fetchestablishmentProfessionalJson();
    return () => {
      isMounted.current = false;
      setOpen(false);
    };
    // eslint-disable-next-line
  }, [appointmentCrud]);

  const handleDeleteDayData = async (padId: any, panId: any) => {
    let appointmentDetailsJson = {};

    if (
      panId === null &&
      padId !== null &&
      padId !== undefined &&
      padId !== ""
    ) {
      Object.assign(appointmentDetailsJson, {
        padId: padId,
        delete: "true",
      });
    }

    if (
      padId === null &&
      panId !== null &&
      panId !== undefined &&
      panId !== ""
    ) {
      Object.assign(appointmentDetailsJson, {
        panId: panId,
        delete: "true",
      });
    }
    setIsExpanded("");
    const response = await postAxios(
      "establishmentProfessionals/appointmentSchedule",
      appointmentDetailsJson,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );
    if (response.toString() === "ERROR") {
      dispatch(
        setSnackbar(
          true,
          4000,
          "warning",
          "Cellmaflex has encounter an issue. Please contact administrator.",
          "top",
          "center"
        )
      );
    } else if (response.toString() !== "" && typeof response !== "object") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          response.toString(),
          "top",
          "center"
        )
      );
      singoutHandler(jwtToken);
      localStorage.removeItem("token");
      history("/signin");
    } else {
      if (response.data === "DeleteSuccess") {
        formik.resetForm();

        dispatch(
          setSnackbar(
            true,
            4000,
            "success",
            "appointment data deleted successfully!",
            "top",
            "center"
          )
        );

        setAppointmentCrud(true);
      }
    }
  };

  const handleSaveDayData = async (
    index: number,
    day: any,
    formik: any,
    weekIndex: any
  ) => {
    let appointmentDetailsJson = {};

    formik.handleSubmit();

    if (
      Object.keys(formik?.errors).length !== 0 &&
      formik?.errors?.hpScheduleJsons[index] !== undefined &&
      formik?.errors?.hpScheduleJsons[index][day] !== undefined &&
      formik?.errors?.hpScheduleJsons[index][day][0] !== undefined
    ) {
      return;
    }

    if (
      formik.values.hpScheduleJsons[index].padid !== "new" &&
      day === null &&
      weekIndex === null
    ) {
      Object.assign(appointmentDetailsJson, {
        padId: formik?.values?.hpScheduleJsons[index].padid,
        clinicTypeId: formik.values.hpScheduleJsons[index].clinicTypeId,
        clinicLocationId:
          formik.values.hpScheduleJsons[index].clinicLocationsId,
        numberOfAppointment:
          formik?.values?.hpScheduleJsons[index]?.noAppointments,
        appointmentDuration:
          formik?.values?.hpScheduleJsons[index]?.timingSlotDuration,
        startTime:
          formik.values.hpScheduleJsons[index].startTime === "" ||
          formik.values.hpScheduleJsons[index].startTime === undefined ||
          formik.values.hpScheduleJsons[index].startTime === null
            ? ""
            : moment(formik?.values?.hpScheduleJsons[index]?.startTime).format(
                "HH:mm"
              ) + ":00",
        endTime:
          formik.values.hpScheduleJsons[index].endTime === "" ||
          formik.values.hpScheduleJsons[index].endTime === undefined ||
          formik.values.hpScheduleJsons[index].endTime === null
            ? ""
            : moment(formik?.values?.hpScheduleJsons[index]?.endTime).format(
                "HH:mm"
              ) + ":00",
      });
    } else if (
      formik?.values?.hpScheduleJsons[index][day] !== undefined &&
      formik.values.hpScheduleJsons[index].padid !== "new" &&
      day !== null
    ) {
      Object.assign(appointmentDetailsJson, {
        day: day,
        clinicTypeId: formik.values.hpScheduleJsons[index].clinicTypeId,
        clinicLocationId:
          formik.values.hpScheduleJsons[index].clinicLocationsId,
        numberOfAppointment:
          formik.values.hpScheduleJsons[index][day][0].noAppointments,
        appointmentDuration:
          formik.values.hpScheduleJsons[index][day][0].timingSlotDuration,
        startTime:
          formik.values.hpScheduleJsons[index][day][0].startTime === "" ||
          formik.values.hpScheduleJsons[index][day][0].startTime ===
            undefined ||
          formik.values.hpScheduleJsons[index][day][0].startTime === null
            ? ""
            : moment(
                formik.values.hpScheduleJsons[index][day][0].startTime
              ).format("HH:mm") + ":00",
        endTime:
          formik.values.hpScheduleJsons[index][day][0].endTime === "" ||
          formik.values.hpScheduleJsons[index][day][0].endTime === undefined ||
          formik.values.hpScheduleJsons[index][day][0].endTime === null
            ? ""
            : moment(
                formik.values.hpScheduleJsons[index][day][0].endTime
              ).format("HH:mm") + ":00",
      });
    }

    if (
      formik.values.hpScheduleJsons[index].padid === "new" &&
      day === null &&
      weekIndex === null
    ) {
      Object.assign(appointmentDetailsJson, {
        clinicTypeId: formik.values.hpScheduleJsons[index].clinicTypeId,
        clinicLocationId:
          formik.values.hpScheduleJsons[index].clinicLocationsId,
        numberOfAppointment:
          formik.values.hpScheduleJsons[index].noAppointments,
        appointmentDuration:
          formik.values.hpScheduleJsons[index].timingSlotDuration,
        startTime:
          formik.values.hpScheduleJsons[index].startTime === "" ||
          formik.values.hpScheduleJsons[index].startTime === undefined ||
          formik.values.hpScheduleJsons[index].startTime === null
            ? ""
            : moment(formik.values.hpScheduleJsons[index].startTime).format(
                "HH:mm"
              ) + ":00",
        endTime:
          formik.values.hpScheduleJsons[index].endTime === "" ||
          formik.values.hpScheduleJsons[index].endTime === undefined ||
          formik.values.hpScheduleJsons[index].endTime === null
            ? ""
            : moment(formik.values.hpScheduleJsons[index].endTime).format(
                "HH:mm"
              ) + ":00",
      });
    }

    if (
      day !== null &&
      weekIndex !== null &&
      formik?.values?.hpScheduleJsons[index][day][weekIndex] !== undefined &&
      formik?.values?.hpScheduleJsons[index][day][weekIndex]?.panid !== "new" &&
      formik?.values?.hpScheduleJsons[index][day][weekIndex]?.panid !== ""
    ) {
      Object.assign(appointmentDetailsJson, {
        panId: formik.values.hpScheduleJsons[index][day][weekIndex].panid,
        day: day,
        clinicTypeId: formik.values.hpScheduleJsons[index].clinicTypeId,
        clinicLocationId:
          formik.values.hpScheduleJsons[index].clinicLocationsId,
        numberOfAppointment:
          formik.values.hpScheduleJsons[index][day][weekIndex].noAppointments,
        appointmentDuration:
          formik.values.hpScheduleJsons[index][day][weekIndex]
            .timingSlotDuration,
        startTime:
          formik.values.hpScheduleJsons[index][day][weekIndex].startTime ===
            "" ||
          formik.values.hpScheduleJsons[index][day][weekIndex].startTime ===
            undefined ||
          formik.values.hpScheduleJsons[index][day][weekIndex].startTime ===
            null
            ? ""
            : moment(
                formik.values.hpScheduleJsons[index][day][weekIndex].startTime
              ).format("HH:mm") + ":00",
        endTime:
          formik.values.hpScheduleJsons[index][day][weekIndex].endTime === "" ||
          formik.values.hpScheduleJsons[index][day][weekIndex].endTime ===
            undefined ||
          formik.values.hpScheduleJsons[index][day][weekIndex].endTime === null
            ? ""
            : moment(
                formik.values.hpScheduleJsons[index][day][weekIndex].endTime
              ).format("HH:mm") + ":00",
      });
    }

    if (
      day !== null &&
      weekIndex !== null &&
      formik?.values?.hpScheduleJsons[index][day][weekIndex] !== undefined &&
      formik?.values?.hpScheduleJsons[index][day][weekIndex]?.panid !== "" &&
      formik?.values?.hpScheduleJsons[index][day][weekIndex]?.panid === "new"
    ) {
      Object.assign(appointmentDetailsJson, {
        day: day,
        clinicTypeId: formik.values.hpScheduleJsons[index].clinicTypeId,
        clinicLocationId:
          formik.values.hpScheduleJsons[index].clinicLocationsId,
        numberOfAppointment:
          formik.values.hpScheduleJsons[index][day][weekIndex].noAppointments,
        appointmentDuration:
          formik.values.hpScheduleJsons[index][day][weekIndex]
            .timingSlotDuration,
        startTime:
          formik.values.hpScheduleJsons[index][day][weekIndex].startTime ===
            "" ||
          formik.values.hpScheduleJsons[index][day][weekIndex].startTime ===
            undefined ||
          formik.values.hpScheduleJsons[index][day][weekIndex].startTime ===
            null
            ? ""
            : moment(
                formik.values.hpScheduleJsons[index][day][weekIndex].startTime
              ).format("HH:mm") + ":00",
        endTime:
          formik.values.hpScheduleJsons[index][day][weekIndex].endTime === "" ||
          formik.values.hpScheduleJsons[index][day][weekIndex].endTime ===
            undefined ||
          formik.values.hpScheduleJsons[index][day][weekIndex].endTime === null
            ? ""
            : moment(
                formik.values.hpScheduleJsons[index][day][weekIndex].endTime
              ).format("HH:mm") + ":00",
      });
    }

    const response = await postAxios(
      "establishmentProfessionals/appointmentSchedule",
      appointmentDetailsJson,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );
    if (response.toString() === "ERROR") {
      dispatch(
        setSnackbar(
          true,
          4000,
          "warning",
          "Cellmaflex has encounter an issue. Please contact administrator.",
          "top",
          "center"
        )
      );
    } else if (response.toString() !== "" && typeof response !== "object") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          response.toString(),
          "top",
          "center"
        )
      );
      singoutHandler(jwtToken);
      localStorage.removeItem("token");
      history("/signin");
    } else {
      if (response.data === "DefaultSuccess") {
        formik.resetForm();
        dispatch(
          setSnackbar(
            true,
            4000,
            "success",
            "Appointment details saved successfully.",
            "top",
            "center"
          )
        );

        setAppointmentCrud(true);
      }

      if (response.data === "NonDefaultSuccess") {
        formik.resetForm();

        dispatch(
          setSnackbar(
            true,
            4000,
            "success",
            "Appointment details saved successfully!",
            "top",
            "center"
          )
        );

        setAppointmentCrud(true);
      }

      if (response.data === "OverlapingWithTimeWithOtherClinic") {
        dispatch(
          setSnackbar(
            true,
            4000,
            "warning",
            "Appointment schedule is overlapping with other clinic timing!",
            "top",
            "center"
          )
        );
      }

      if (response.data === "OverlappingDefault") {
        dispatch(
          setSnackbar(
            true,
            4000,
            "warning",
            "Default record exist with same clinic type and clinic location!",
            "top",
            "center"
          )
        );
      }
      if (response.data === "Failed") {
        dispatch(
          setSnackbar(
            true,
            4000,
            "warning",
            "There is issue while saving appointment details.Please contact administrator.",
            "top",
            "center"
          )
        );
      }
    }
  };

  const isError = (value: any) => {
    let error =
      Boolean(getIn(formik.touched, value)) &&
      Boolean(getIn(formik.errors, value));
    return error;
  };

  const setTouch = (index: any, day: any) => {
    formik.setFieldTouched(
      `hpScheduleJsons[${index}].${day}[0].noAppointments`
    );
    formik.setFieldTouched(
      `hpScheduleJsons[${index}].${day}[0].timingSlotDuration`
    );
    formik.setFieldTouched(`hpScheduleJsons[${index}].${day}[0].startTime`);
    formik.setFieldTouched(`hpScheduleJsons[${index}].${day}[0].endTime`);
  };

  const handleMarkAsLeave = (index: any, day: any, newValue: any) => {
    formik.setFieldValue(
      `hpScheduleJsons[${index}].${day}[0].markAsLeave`,
      newValue
    );

    formik.setFieldValue(
      `hpScheduleJsons[${index}].${day}[0].noAppointments`,
      ""
    );
    formik.setFieldValue(
      `hpScheduleJsons[${index}].${day}[0].timingSlotDuration`,
      ""
    );

    formik.setFieldValue(`hpScheduleJsons[${index}].${day}[0].startTime`, null);
    formik.setFieldValue(`hpScheduleJsons[${index}].${day}[0].endTime`, null);
    formik.setFieldTouched(
      `hpScheduleJsons[${index}].${day}[0].startTime`,
      false
    );
    formik.setFieldTouched(
      `hpScheduleJsons[${index}].${day}[0].endTime`,
      false
    );
  };

  const handleDaySave = (index: any, day: any, weekIndex: any) => {
    if (
      getIn(
        formik.errors,
        `hpScheduleJsons[${index}].${day}[${weekIndex}].noAppointments`
      ) ||
      getIn(
        formik.errors,
        `hpScheduleJsons[${index}].${day}[${weekIndex}].timingSlotDuration`
      ) ||
      getIn(
        formik.errors,
        `hpScheduleJsons[${index}].${day}[${weekIndex}].startTime`
      ) ||
      getIn(
        formik.errors,
        `hpScheduleJsons[${index}].${day}[${weekIndex}].endTime`
      )
    ) {
      formik.setFieldTouched(
        `hpScheduleJsons[${index}].${day}[${weekIndex}].noAppointments`
      );
      formik.setFieldTouched(
        `hpScheduleJsons[${index}].${day}[${weekIndex}].timingSlotDuration`
      );
      formik.setFieldTouched(
        `hpScheduleJsons[${index}].${day}[${weekIndex}].startTime`
      );
      formik.setFieldTouched(
        `hpScheduleJsons[${index}].${day}[${weekIndex}].endTime`
      );

      formik.setFieldValue(
        `hpScheduleJsons[${index}].${day}[${weekIndex}].startTime`,
        null
      );

      formik.setFieldValue(
        `hpScheduleJsons[${index}].${day}[${weekIndex}].endTime`,
        null
      );
      return true;
    } else {
      return false;
    }
  };

  const handleDayValueChange = (event: any, index: any, day: any) => {
    formik.handleChange(event);
    formik.setFieldValue(
      `hpScheduleJsons[${index}].${day}[0].markAsLeave`,
      false
    );
  };

  let dayValidationSchema = Yup.array().of(
    Yup.object().shape({
      noAppointments: Yup.string()
        .nullable()
        .when("markAsLeave", {
          is: false,
          then: () =>
            Yup.string()
              .nullable()
              .required("Please select number of appointment"),
        }),

      timingSlotDuration: Yup.string()
        .nullable()
        .when("markAsLeave", {
          is: false,
          then: () =>
            Yup.string().nullable().required("Please select duration"),
        }),
      startTime: Yup.string()
        .nullable()
        .when("markAsLeave", {
          is: false,
          then: () =>
            Yup.string()
              .nullable()
              .required("Please select start time")
              .test("startTime", "startTime", (value: any, context: any) => {
                return true;
              }),
        }),

      endTime: Yup.string()
        .nullable()
        .when("markAsLeave", {
          is: false,
          then: () =>
            Yup.string()
              .nullable()
              .required("Please select end time")
              .test(
                "endTime",
                "End Time must be more than Start Time",
                (value: any, context: any) => {
                  if (
                    value !== undefined &&
                    value !== "" &&
                    value !== null &&
                    context.parent.startTime !== undefined &&
                    context.parent.startTime !== null
                  ) {
                    return moment(value).isAfter(
                      moment(context.parent.startTime)
                    );
                  }
                  return true;
                }
              ),
        }),
    })
  );

  let dayInitialValues = [
    {
      dayId: "",
      padid: "",
      panid: "",
      noAppointments: "",
      timingSlotDuration: "",
      startTime: null,
      endTime: null,
      markAsLeave: false,
    },
  ];

  const formik = useFormik({
    initialValues: {
      hpScheduleJsons: [
        {
          hpScJsonId: "",
          padid: "",
          panid: "",
          clinicTypeId: "",
          clinicLocationsId: "",
          clinicType: "",
          clinicLocations: "",
          noAppointments: "",
          timingSlotDuration: "",
          startTime: "",
          endTime: "",
          monday: dayInitialValues,
          tuesday: dayInitialValues,
          wednesday: dayInitialValues,
          thursday: dayInitialValues,
          friday: dayInitialValues,
          saturday: dayInitialValues,
          sunday: dayInitialValues,
        },
      ],
    },
    validationSchema: Yup.object({
      hpScheduleJsons: Yup.array().of(
        Yup.object().shape({
          clinicType: Yup.string().required("Please select clinic type"),
          clinicLocations: Yup.string().required(
            "Please select clinic location"
          ),
          noAppointments: Yup.string()
            .nullable()
            .required("Please select number of appointment"),
          timingSlotDuration: Yup.string().required("Please select duration"),
          startTime: Yup.string()
            .nullable()
            .required("Please select start time"),

          endTime: Yup.string()
            .nullable()
            .required("Please select end time")
            .test(
              "endTime",
              "End Time must be more than Start Time",
              (value: any, context: any) => {
                if (
                  value !== undefined &&
                  value !== "" &&
                  value !== null &&
                  context.parent.startTime !== undefined &&
                  context.parent.startTime !== null
                ) {
                  return moment(value).isAfter(
                    moment(context.parent.startTime)
                  );
                }
                return true;
              }
            ),
          monday: dayValidationSchema,
          tuesday: dayValidationSchema,
          wednesday: dayValidationSchema,
          thursday: dayValidationSchema,
          friday: dayValidationSchema,
          saturday: dayValidationSchema,
          sunday: dayValidationSchema,
        })
      ),
    }),

    onSubmit: (value) => {},
  });

  return (
    <CommonLayout showHeaderNavigation={true} isLogedIn={true}>
      <CommonCard>
        <Grid
          container
          spacing={2}
          className={classes.rowSpace}
          direction="row"
          sx={{ marginBottom: "20px" }}
        >
          <Grid item xs={12} md={12}>
            <Grid item md={12}>
              <Typography variant="h6" className={globalClasses.typography}>
                Hp Default/Non-default Appointment Schedule
              </Typography>
              {open && (
                <Box className={globalClasses.loader}>
                  <CircularProgress color="primary" disableShrink />
                </Box>
              )}
            </Grid>
          </Grid>

          {!open && (
            <FormikProvider value={formik}>
              <Grid item xs={12} md={12}>
                <FieldArray
                  name="hpScheduleJsons"
                  render={(arrayHelpers) => (
                    <Box className={classes.tabbackgroundcolor}>
                      {formik?.values?.hpScheduleJsons?.map(
                        (hpScheduleJsons: any, index: any) => (
                          <Grid container sx={{ mb: "20px" }} key={hpScheduleJsons.hpScJsonId}>
                            <Grid
                              item
                              xs={2}
                              sm={1}
                              md={0.5}
                              sx={{ display: "flex", alignItems: "center" }}
                            >
                              {isExpanded === index ? (
                                <BootstrapTooltip title="Show Non-default Record">
                                  <IconButton onClick={() => setIsExpanded("")}>
                                    <ExpandCircleDownOutlinedIcon
                                      sx={{
                                        color: "#218838",
                                        rotate: "180deg",
                                      }}
                                    />
                                  </IconButton>
                                </BootstrapTooltip>
                              ) : (
                                <BootstrapTooltip title="Show Non-default Record">
                                  <IconButton
                                    onClick={() => setIsExpanded(index)}
                                    disabled={
                                      hpScheduleJsons.padid === "new" ||
                                      hpScheduleJsons.padid === ""
                                        ? true
                                        : false
                                    }
                                  >
                                    <ExpandCircleDownOutlinedIcon
                                      sx={{
                                        color:
                                          hpScheduleJsons.padid === "new"
                                            ? "disabled"
                                            : "#218838",
                                      }}
                                    />
                                  </IconButton>
                                </BootstrapTooltip>
                              )}
                            </Grid>
                            <Grid
                              item
                              xs={10}
                              sm={11}
                              md={10.5}
                              container
                              spacing={1}
                            >
                              <Grid item xs={12} sm={4} md={4}>
                                <input
                                  type="hidden"
                                  id={`hpScheduleJsons[${index}].padid`}
                                  name={`hpScheduleJsons[${index}].padid`}
                                  value={hpScheduleJsons.padid ?? ""}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                />
                                <input
                                  type="hidden"
                                  id={`hpScheduleJsons[${index}].panid`}
                                  name={`hpScheduleJsons[${index}].panid`}
                                  value={hpScheduleJsons.panid ?? ""}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                />
                                <input
                                  type="hidden"
                                  id={`hpScheduleJsons[${index}].clinicTypeId`}
                                  name={`hpScheduleJsons[${index}].clinicTypeId`}
                                  value={hpScheduleJsons.clinicTypeId ?? ""}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                />
                                <input
                                  type="hidden"
                                  id={`hpScheduleJsons[${index}].clinicLocationsId`}
                                  name={`hpScheduleJsons[${index}].clinicLocationsId`}
                                  value={
                                    hpScheduleJsons.clinicLocationsId ?? ""
                                  }
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                />

                                <SelectField
                                  id={`hpScheduleJsons[${index}].clinicType`}
                                  name={`hpScheduleJsons[${index}].clinicType`}
                                  headerText="Select Clinic Type"
                                  label="Select Clinic Type"
                                  value={hpScheduleJsons.clinicType}
                                  disable={
                                    hpScheduleJsons.clinicType &&
                                    hpScheduleJsons.padid !== "new" &&
                                    hpScheduleJsons.padid !== ""
                                      ? true
                                      : false
                                  }
                                  blurevent={formik.handleBlur}
                                  changeevent={(event: any) => {
                                    formik.handleChange(event);
                                  }}
                                  isrequired={true}
                                  list={
                                    hpScheduleJsons.clinicType &&
                                    hpScheduleJsons.padid !== "new" ? (
                                      <MenuItem
                                        value={hpScheduleJsons.clinicType}
                                      >
                                        {hpScheduleJsons.clinicType}
                                      </MenuItem>
                                    ) : (
                                      clinicType?.map((clinicType: any) => (
                                        <MenuItem
                                          key={clinicType.clinicTypeEliId}
                                          value={clinicType.clinicTypeEliText}
                                          onClick={(event: any) => {
                                            formik.setFieldValue(
                                              `hpScheduleJsons[${index}].clinicTypeId`,
                                              clinicType.clinicTypeEliId
                                            );
                                            formik.setFieldValue(
                                              `hpScheduleJsons[${index}].clinicLocations`,
                                              ""
                                            );
                                            fetchClinicLocation(
                                              clinicType.clinicTypeEliId
                                            );
                                          }}
                                        >
                                          {clinicType.clinicTypeEliText}
                                        </MenuItem>
                                      ))
                                    )
                                  }
                                  error={isError(
                                    `hpScheduleJsons[${index}].clinicType`
                                  )}
                                />
                                {isError(
                                  `hpScheduleJsons[${index}].clinicType`
                                ) && (
                                  <Typography sx={styles.errorMessage}>
                                    <ErrorMessage
                                      name={`hpScheduleJsons[${index}].clinicType`}
                                    />
                                  </Typography>
                                )}
                              </Grid>
                              <Grid item xs={12} sm={4} md={4}>
                                <SelectField
                                  id={`hpScheduleJsons[${index}].clinicLocations`}
                                  name={`hpScheduleJsons[${index}].clinicLocations`}
                                  headerText="Select Clinic Location"
                                  label="Select Clinic Location"
                                  value={hpScheduleJsons.clinicLocations}
                                  disable={
                                    hpScheduleJsons.clinicLocations &&
                                    hpScheduleJsons.padid !== "new" &&
                                    hpScheduleJsons.padid !== ""
                                      ? true
                                      : false
                                  }
                                  blurevent={formik.handleBlur}
                                  changeevent={formik.handleChange}
                                  isrequired={true}
                                  list={
                                    hpScheduleJsons.clinicLocations &&
                                    hpScheduleJsons.padid !== "new" ? (
                                      <MenuItem
                                        value={hpScheduleJsons.clinicLocations}
                                      >
                                        {hpScheduleJsons.clinicLocations}
                                      </MenuItem>
                                    ) : (
                                      clinicLocation?.map(
                                        (clinicLocation: any) => (
                                          <MenuItem
                                            key={
                                              clinicLocation.clinicLocationEliId
                                            }
                                            value={
                                              clinicLocation.clinicLocationEliText
                                            }
                                            onClick={(event: any) => {
                                              formik.setFieldValue(
                                                `hpScheduleJsons[${index}].clinicLocationsId`,
                                                clinicLocation.clinicLocationEliId
                                              );
                                            }}
                                          >
                                            {
                                              clinicLocation.clinicLocationEliText
                                            }
                                          </MenuItem>
                                        )
                                      )
                                    )
                                  }
                                  error={isError(
                                    `hpScheduleJsons[${index}].clinicLocations`
                                  )}
                                />
                                {isError(
                                  `hpScheduleJsons[${index}].clinicType`
                                ) && (
                                  <Typography sx={styles.errorMessage}>
                                    <ErrorMessage
                                      name={`hpScheduleJsons[${index}].clinicLocations`}
                                    />
                                  </Typography>
                                )}
                              </Grid>
                              <Grid item xs={12} sm={4} md={4}>
                                <InputField
                                  id={`hpScheduleJsons[${index}].noAppointments`}
                                  name={`hpScheduleJsons[${index}].noAppointments`}
                                  label="No Of Appointments"
                                  inputvalues={hpScheduleJsons.noAppointments}
                                  changeevent={formik.handleChange}
                                  blurevent={formik.handleBlur}
                                  isrequired={true}
                                  errormessage={isError(
                                    `hpScheduleJsons[${index}].noAppointments`
                                  )}
                                  message={
                                    <ErrorMessage
                                      name={`hpScheduleJsons[${index}].noAppointments`}
                                    />
                                  }
                                />
                              </Grid>

                              <Grid item xs={12} sm={4} md={4}>
                                <TimeComponent
                                  label="Start Time"
                                  value={
                                    formik.values.hpScheduleJsons[index]
                                      .startTime
                                  }
                                  isrequired={true}
                                  onChange={(newValue: any) => {
                                    formik.setFieldValue(
                                      `hpScheduleJsons[${index}].startTime`,
                                      newValue
                                    );
                                  }}
                                  error={
                                    !formik.values.hpScheduleJsons[index]
                                      .startTime &&
                                    getIn(
                                      formik.errors,
                                      `hpScheduleJsons[${index}].startTime`
                                    )
                                  }
                                />
                              </Grid>
                              <Grid item xs={12} sm={4} md={4}>
                                <TimeComponent
                                  label="End Time"
                                  value={hpScheduleJsons?.endTime}
                                  isrequired={true}
                                  onChange={(newValue: any) => {
                                    formik.setFieldValue(
                                      `hpScheduleJsons[${index}].endTime`,
                                      newValue
                                    );
                                  }}
                                  error={
                                    !formik.values.hpScheduleJsons[index]
                                      .endTime &&
                                    getIn(
                                      formik.errors,
                                      `hpScheduleJsons[${index}].endTime`
                                    )
                                  }
                                />
                              </Grid>
                              <Grid item xs={12} sm={4} md={4}>
                                <SelectField
                                  id={`hpScheduleJsons[${index}].timingSlotDuration`}
                                  name={`hpScheduleJsons[${index}].timingSlotDuration`}
                                  headerText="Duration(min)"
                                  label="Select Duration"
                                  options={TIMINGSLOTDURATION}
                                  isrequired={true}
                                  value={hpScheduleJsons.timingSlotDuration}
                                  changeevent={formik.handleChange}
                                  blurevent={formik.handleBlur}
                                  error={isError(
                                    `hpScheduleJsons[${index}].timingSlotDuration`
                                  )}
                                />
                                {isError(
                                  `hpScheduleJsons[${index}].timingSlotDuration`
                                ) && (
                                  <Typography sx={styles.errorMessage}>
                                    <ErrorMessage
                                      name={`hpScheduleJsons[${index}].timingSlotDuration`}
                                    />
                                  </Typography>
                                )}
                              </Grid>
                            </Grid>
                            <Grid container item xs={12} sm={12} md={1}>
                              <Grid
                                item
                                xs={12}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  alignItems: "baseline",
                                }}
                              >
                                {" "}
                                <Tooltip title="Delete">
                                  <DeleteForeverOutlinedIcon
                                    color="error"
                                    onClick={() => {
                                      if (
                                        hpScheduleJsons.padid !== "" &&
                                        hpScheduleJsons.padid !== "new"
                                      ) {
                                        handleDeleteDayData(
                                          hpScheduleJsons.padid,
                                          null
                                        );
                                        arrayHelpers.form.values.hpScheduleJsons
                                          .length !== 1
                                          ? arrayHelpers.remove(index)
                                          : arrayHelpers.remove(1);
                                      } else {
                                        arrayHelpers.form.values.hpScheduleJsons
                                          .length !== 1
                                          ? arrayHelpers.remove(index)
                                          : arrayHelpers.remove(1);
                                      }
                                    }}
                                  />
                                </Tooltip>
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  alignItems: "center",
                                }}
                              >
                                <ButtonComponent
                                  variant="contained"
                                  size="small"
                                  type="button"
                                  buttonclass={classes.saveButton}
                                  sx={{ minWidth: "20px" }}
                                  onClick={() => {
                                    if (
                                      getIn(
                                        formik.errors,
                                        `hpScheduleJsons[${index}].clinicType`
                                      ) ||
                                      getIn(
                                        formik.errors,
                                        `hpScheduleJsons[${index}].clinicLocations`
                                      ) ||
                                      getIn(
                                        formik.errors,
                                        `hpScheduleJsons[${index}].noAppointments`
                                      ) ||
                                      getIn(
                                        formik.errors,
                                        `hpScheduleJsons[${index}].startTime`
                                      ) ||
                                      getIn(
                                        formik.errors,
                                        `hpScheduleJsons[${index}].endTime`
                                      ) ||
                                      getIn(
                                        formik.errors,
                                        `hpScheduleJsons[${index}].timingSlotDuration`
                                      )
                                    ) {
                                      formik.setFieldTouched(
                                        `hpScheduleJsons[${index}].clinicType`
                                      );
                                      formik.setFieldTouched(
                                        `hpScheduleJsons[${index}].clinicLocations`
                                      );
                                      formik.setFieldTouched(
                                        `hpScheduleJsons[${index}].noAppointments`
                                      );
                                      formik.setFieldTouched(
                                        `hpScheduleJsons[${index}].startTime`
                                      );
                                      formik.setFieldTouched(
                                        `hpScheduleJsons[${index}].endTime`
                                      );
                                      formik.setFieldTouched(
                                        `hpScheduleJsons[${index}].timingSlotDuration`
                                      );
                                      formik.setFieldValue(
                                        `hpScheduleJsons[${index}].startTime`,
                                        null
                                      );

                                      formik.setFieldValue(
                                        `hpScheduleJsons[${index}].endTime`,
                                        null
                                      );
                                    } else {
                                      handleSaveDayData(
                                        index,
                                        null,
                                        formik,
                                        null
                                      );
                                    }
                                  }}
                                  disable={
                                    hpScheduleJsons.clinicType === "" &&
                                    hpScheduleJsons.clinicLocations === "" &&
                                    hpScheduleJsons.timingSlotDuration === "" &&
                                    hpScheduleJsons.noAppointments === "" &&
                                    hpScheduleJsons.startTime === "" &&
                                    hpScheduleJsons.endTime === ""
                                      ? true
                                      : false
                                  }
                                  label="Save"
                                />
                              </Grid>
                            </Grid>
                            <Grid item sx={{ mt: "20px" }} xs={12}>
                              <Collapse
                                in={isExpanded === index}
                                timeout="auto"
                                unmountOnExit
                                sx={{ marginBottom: "20px" }}
                              >
                                <Grid
                                  container
                                  spacing={1}
                                  sx={{ marginBottom: "20px" }}
                                >
                                  <Grid item xs={12} sm={12} md={1.5}>
                                    <Typography sx={styles.dayText}>
                                      Monday
                                    </Typography>
                                  </Grid>

                                  <FieldArray
                                    name={`hpScheduleJsons[${index}].monday`}
                                    render={(arrayHelpers) => (
                                      <>
                                        {hpScheduleJsons.monday.map(
                                          (monday: any, weekIndex: any) => {
                                            return (
                                              <Fragment key={monday.dayId}>
                                                {weekIndex !== 0 && (
                                                  <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={1.5}
                                                  ></Grid>
                                                )}
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <input
                                                    type="hidden"
                                                    id={`hpScheduleJsons[${index}].monday[${weekIndex}].padid`}
                                                    name={`hpScheduleJsons[${index}].monday[${weekIndex}].padid`}
                                                    value={
                                                      hpScheduleJsons.monday[
                                                        weekIndex
                                                      ]?.padid ?? ""
                                                    }
                                                    onChange={
                                                      formik.handleChange
                                                    }
                                                    onBlur={formik.handleBlur}
                                                  />
                                                  <input
                                                    type="hidden"
                                                    id={`hpScheduleJsons[${index}].monday[${weekIndex}].panid`}
                                                    name={`hpScheduleJsons[${index}].monday[${weekIndex}].panid`}
                                                    value={
                                                      hpScheduleJsons.monday[
                                                        weekIndex
                                                      ]?.panid ?? ""
                                                    }
                                                    onChange={
                                                      formik.handleChange
                                                    }
                                                    onBlur={formik.handleBlur}
                                                  />
                                                  <InputField
                                                    id={`hpScheduleJsons[${index}].monday[${weekIndex}].noAppointments`}
                                                    name={`hpScheduleJsons[${index}].monday[${weekIndex}].noAppointments`}
                                                    label="No Of Appointments"
                                                    inputvalues={
                                                      hpScheduleJsons.monday[
                                                        weekIndex
                                                      ]?.noAppointments ?? ""
                                                    }
                                                    isrequired={true}
                                                    changeevent={(
                                                      event: any
                                                    ) => {
                                                      handleDayValueChange(
                                                        event,
                                                        index,
                                                        "monday"
                                                      );
                                                    }}
                                                    blurevent={
                                                      formik.handleBlur
                                                    }
                                                    errormessage={isError(
                                                      `hpScheduleJsons[${index}].monday[${weekIndex}].noAppointments`
                                                    )}
                                                    message={
                                                      <ErrorMessage
                                                        name={`hpScheduleJsons[${index}].monday[${weekIndex}].noAppointments`}
                                                      />
                                                    }
                                                  />
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <SelectField
                                                    id={`hpScheduleJsons[${index}].monday[${weekIndex}].timingSlotDuration`}
                                                    name={`hpScheduleJsons[${index}].monday[${weekIndex}].timingSlotDuration`}
                                                    headerText="Duration(min)"
                                                    label="Select Duration"
                                                    options={TIMINGSLOTDURATION}
                                                    isrequired={true}
                                                    value={
                                                      hpScheduleJsons.monday[
                                                        weekIndex
                                                      ]?.timingSlotDuration ??
                                                      ""
                                                    }
                                                    changeevent={(
                                                      event: any
                                                    ) => {
                                                      handleDayValueChange(
                                                        event,
                                                        index,
                                                        "monday"
                                                      );
                                                    }}
                                                    blurevent={
                                                      formik.handleBlur
                                                    }
                                                    error={isError(
                                                      `hpScheduleJsons[${index}].monday[${weekIndex}].timingSlotDuration`
                                                    )}
                                                  />
                                                  {isError(
                                                    `hpScheduleJsons[${index}].monday[${weekIndex}].timingSlotDuration`
                                                  ) && (
                                                    <Typography
                                                      sx={styles.errorMessage}
                                                    >
                                                      <ErrorMessage
                                                        name={`hpScheduleJsons[${index}].monday[${weekIndex}].timingSlotDuration`}
                                                      />
                                                    </Typography>
                                                  )}
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <TimeComponent
                                                    label="Start Time"
                                                    isrequired={true}
                                                    value={
                                                      hpScheduleJsons.monday[
                                                        weekIndex
                                                      ]?.startTime ?? null
                                                    }
                                                    onChange={(
                                                      newValue: any,
                                                      event: any
                                                    ) => {
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].monday[${weekIndex}].startTime`,
                                                        newValue
                                                      );
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].monday[${weekIndex}].markAsLeave`,
                                                        false
                                                      );
                                                    }}
                                                    error={
                                                      getIn(
                                                        formik.touched,
                                                        `hpScheduleJsons[${index}].monday[${weekIndex}].startTime`
                                                      ) &&
                                                      getIn(
                                                        formik.errors,
                                                        `hpScheduleJsons[${index}].monday[${weekIndex}].startTime`
                                                      )
                                                    }
                                                  />
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <TimeComponent
                                                    label="End Time"
                                                    isrequired={true}
                                                    value={
                                                      hpScheduleJsons.monday[
                                                        weekIndex
                                                      ]?.endTime ?? null
                                                    }
                                                    onChange={(
                                                      newValue: any
                                                    ) => {
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].monday[${weekIndex}].endTime`,
                                                        newValue
                                                      );
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].monday[${weekIndex}].markAsLeave`,
                                                        false
                                                      );
                                                    }}
                                                    error={
                                                      getIn(
                                                        formik.touched,
                                                        `hpScheduleJsons[${index}].monday[${weekIndex}].endTime`
                                                      ) &&
                                                      getIn(
                                                        formik.errors,
                                                        `hpScheduleJsons[${index}].monday[${weekIndex}].endTime`
                                                      )
                                                    }
                                                  />
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  {weekIndex === 0 && (
                                                    <FormControlLabel
                                                      className={
                                                        classes.setAsDefault
                                                      }
                                                      control={
                                                        <Checkbox
                                                          id={`hpScheduleJsons[${index}].monday[${weekIndex}].markAsLeave`}
                                                          name={`hpScheduleJsons[${index}].monday[${weekIndex}].markAsLeave`}
                                                          value={
                                                            hpScheduleJsons
                                                              .monday[weekIndex]
                                                              ?.markAsLeave
                                                          }
                                                          size="small"
                                                          checked={Boolean(
                                                            hpScheduleJsons
                                                              ?.monday[
                                                              weekIndex
                                                            ]?.markAsLeave
                                                          )}
                                                        />
                                                      }
                                                      label="Mark as leave"
                                                      value={
                                                        hpScheduleJsons.monday[
                                                          weekIndex
                                                        ].markAsLeave
                                                      }
                                                      onChange={(
                                                        event: any,
                                                        newValue: any
                                                      ) => {
                                                        handleMarkAsLeave(
                                                          index,
                                                          "monday",
                                                          newValue
                                                        );
                                                      }}
                                                      onBlur={formik.handleBlur}
                                                    />
                                                  )}
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.5}
                                                >
                                                  <Stack
                                                    sx={{
                                                      flexDirection: "row",
                                                      justifyContent:
                                                        "flex-end",
                                                    }}
                                                  >
                                                    {weekIndex !== 0 && (
                                                      <Tooltip title="Delete">
                                                        <DeleteForeverOutlinedIcon
                                                          sx={{
                                                            marginTop: "5px",
                                                          }}
                                                          color="error"
                                                          onClick={() => {
                                                            if (
                                                              hpScheduleJsons
                                                                .monday[
                                                                weekIndex
                                                              ]?.panid !== "" &&
                                                              hpScheduleJsons
                                                                .monday[
                                                                weekIndex
                                                              ]?.panid !== "new"
                                                            ) {
                                                              handleDeleteDayData(
                                                                null,
                                                                hpScheduleJsons
                                                                  .monday[
                                                                  weekIndex
                                                                ]?.panid
                                                              );
                                                              arrayHelpers.form
                                                                .values
                                                                .hpScheduleJsons[
                                                                index
                                                              ].monday
                                                                .length !== 1
                                                                ? arrayHelpers.remove(
                                                                    weekIndex
                                                                  )
                                                                : arrayHelpers.remove(
                                                                    1
                                                                  );
                                                            } else {
                                                              arrayHelpers.form
                                                                .values
                                                                .hpScheduleJsons[
                                                                index
                                                              ].monday
                                                                .length !== 1
                                                                ? arrayHelpers.remove(
                                                                    weekIndex
                                                                  )
                                                                : arrayHelpers.remove(
                                                                    1
                                                                  );
                                                            }
                                                          }}
                                                        />
                                                      </Tooltip>
                                                    )}
                                                    <ButtonComponent
                                                      variant="contained"
                                                      size="small"
                                                      type="button"
                                                      buttonclass={
                                                        classes.saveButton
                                                      }
                                                      sx={{ minWidth: "20px" }}
                                                      onClick={() => {
                                                        if (
                                                          handleDaySave(
                                                            index,
                                                            "monday",
                                                            weekIndex
                                                          ) === false
                                                        ) {
                                                          handleSaveDayData(
                                                            index,
                                                            "monday",
                                                            formik,
                                                            weekIndex
                                                          );
                                                        } else {
                                                          setTouch(
                                                            index,
                                                            "monday"
                                                          );
                                                        }
                                                      }}
                                                      label="Save"
                                                    />
                                                  </Stack>
                                                </Grid>
                                              </Fragment>
                                            );
                                          }
                                        )}

                                        <Grid
                                          item
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          sx={{ marginTop: "20px" }}
                                        >
                                          {hpScheduleJsons.monday[0]?.panid !==
                                            "" &&
                                            hpScheduleJsons.monday[0]?.panid !==
                                              undefined &&
                                            hpScheduleJsons.monday[0]?.panid !==
                                              null && (
                                              <ButtonComponent
                                                buttonclass={
                                                  globalClasses.addButton
                                                }
                                                sx={{
                                                  maxWidth: "50px !importanat",
                                                  display:
                                                    arrayHelpers.form.values
                                                      .hpScheduleJsons[index]
                                                      .monday.length <= 1
                                                      ? "block"
                                                      : "none",
                                                }}
                                                variant="contained"
                                                label="Add"
                                                onClick={(e: any) => {
                                                  e.preventDefault();
                                                  arrayHelpers.form.values
                                                    .hpScheduleJsons[index]
                                                    .monday.length <= 1 &&
                                                    arrayHelpers.push({
                                                      padid: "new",
                                                      panid: "new",
                                                      noAppointments: "",
                                                      timingSlotDuration: "",
                                                      startTime: null,
                                                      endTime: null,
                                                      markAsLeave: false,
                                                    });
                                                }}
                                              />
                                            )}
                                        </Grid>
                                      </>
                                    )}
                                  />
                                </Grid>

                                <Grid
                                  container
                                  spacing={1}
                                  sx={{ marginBottom: "20px" }}
                                >
                                  <Grid item xs={12} sm={12} md={1.5}>
                                    <Typography sx={styles.dayText}>
                                      Tuesday
                                    </Typography>
                                  </Grid>
                                  <FieldArray
                                    name={`hpScheduleJsons[${index}].tuesday`}
                                    render={(arrayHelpers) => (
                                      <>
                                        {hpScheduleJsons.tuesday.map(
                                          (tuesday: any, weekIndex: any) => {
                                            return (
                                              <Fragment key={tuesday.dayId}>
                                                {weekIndex !== 0 && (
                                                  <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={1.5}
                                                  ></Grid>
                                                )}
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <input
                                                    type="hidden"
                                                    id={`hpScheduleJsons[${index}].tuesday[${weekIndex}].padid`}
                                                    name={`hpScheduleJsons[${index}].tuesday[${weekIndex}].padid`}
                                                    value={
                                                      hpScheduleJsons.tuesday[
                                                        weekIndex
                                                      ]?.padid ?? ""
                                                    }
                                                    onChange={
                                                      formik.handleChange
                                                    }
                                                    onBlur={formik.handleBlur}
                                                  />
                                                  <input
                                                    type="hidden"
                                                    id={`hpScheduleJsons[${index}].tuesday[${weekIndex}].panid`}
                                                    name={`hpScheduleJsons[${index}].tuesday[${weekIndex}].panid`}
                                                    value={
                                                      hpScheduleJsons.tuesday[
                                                        weekIndex
                                                      ]?.panid ?? ""
                                                    }
                                                    onChange={
                                                      formik.handleChange
                                                    }
                                                    onBlur={formik.handleBlur}
                                                  />
                                                  <InputField
                                                    id={`hpScheduleJsons[${index}].tuesday[${weekIndex}].noAppointments`}
                                                    name={`hpScheduleJsons[${index}].tuesday[${weekIndex}].noAppointments`}
                                                    label="No Of Appointments"
                                                    inputvalues={
                                                      hpScheduleJsons.tuesday[
                                                        weekIndex
                                                      ]?.noAppointments ?? ""
                                                    }
                                                    isrequired={true}
                                                    changeevent={(
                                                      event: any
                                                    ) => {
                                                      handleDayValueChange(
                                                        event,
                                                        index,
                                                        "tuesday"
                                                      );
                                                    }}
                                                    blurevent={
                                                      formik.handleBlur
                                                    }
                                                    errormessage={isError(
                                                      `hpScheduleJsons[${index}].tuesday[${weekIndex}].noAppointments`
                                                    )}
                                                    message={
                                                      <ErrorMessage
                                                        name={`hpScheduleJsons[${index}].tuesday[${weekIndex}].noAppointments`}
                                                      />
                                                    }
                                                  />
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <SelectField
                                                    id={`hpScheduleJsons[${index}].tuesday[${weekIndex}].timingSlotDuration`}
                                                    name={`hpScheduleJsons[${index}].tuesday[${weekIndex}].timingSlotDuration`}
                                                    headerText="Duration(min)"
                                                    label="Select Duration"
                                                    options={TIMINGSLOTDURATION}
                                                    isrequired={true}
                                                    value={
                                                      hpScheduleJsons.tuesday[
                                                        weekIndex
                                                      ]?.timingSlotDuration ??
                                                      ""
                                                    }
                                                    changeevent={(
                                                      event: any
                                                    ) => {
                                                      handleDayValueChange(
                                                        event,
                                                        index,
                                                        "tuesday"
                                                      );
                                                    }}
                                                    blurevent={
                                                      formik.handleBlur
                                                    }
                                                    error={isError(
                                                      `hpScheduleJsons[${index}].tuesday[${weekIndex}].timingSlotDuration`
                                                    )}
                                                  />
                                                  {isError(
                                                    `hpScheduleJsons[${index}].tuesday[${weekIndex}].timingSlotDuration`
                                                  ) && (
                                                    <Typography
                                                      sx={styles.errorMessage}
                                                    >
                                                      <ErrorMessage
                                                        name={`hpScheduleJsons[${index}].tuesday[${weekIndex}].timingSlotDuration`}
                                                      />
                                                    </Typography>
                                                  )}
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <TimeComponent
                                                    label="Start Time"
                                                    isrequired={true}
                                                    value={
                                                      hpScheduleJsons.tuesday[
                                                        weekIndex
                                                      ]?.startTime ?? null
                                                    }
                                                    onChange={(
                                                      newValue: any,
                                                      event: any
                                                    ) => {
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].tuesday[${weekIndex}].startTime`,
                                                        newValue
                                                      );
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].tuesday[${weekIndex}].markAsLeave`,
                                                        false
                                                      );
                                                    }}
                                                    error={
                                                      getIn(
                                                        formik.touched,
                                                        `hpScheduleJsons[${index}].tuesday[${weekIndex}].startTime`
                                                      ) &&
                                                      getIn(
                                                        formik.errors,
                                                        `hpScheduleJsons[${index}].tuesday[${weekIndex}].startTime`
                                                      )
                                                    }
                                                  />
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <TimeComponent
                                                    label="End Time"
                                                    isrequired={true}
                                                    value={
                                                      hpScheduleJsons.tuesday[
                                                        weekIndex
                                                      ]?.endTime ?? null
                                                    }
                                                    onChange={(
                                                      newValue: any
                                                    ) => {
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].tuesday[${weekIndex}].endTime`,
                                                        newValue
                                                      );
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].tuesday[${weekIndex}].markAsLeave`,
                                                        false
                                                      );
                                                    }}
                                                    error={
                                                      getIn(
                                                        formik.touched,
                                                        `hpScheduleJsons[${index}].tuesday[${weekIndex}].endTime`
                                                      ) &&
                                                      getIn(
                                                        formik.errors,
                                                        `hpScheduleJsons[${index}].tuesday[${weekIndex}].endTime`
                                                      )
                                                    }
                                                  />
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  {weekIndex === 0 && (
                                                    <FormControlLabel
                                                      className={
                                                        classes.setAsDefault
                                                      }
                                                      control={
                                                        <Checkbox
                                                          id={`hpScheduleJsons[${index}].tuesday[${weekIndex}].markAsLeave`}
                                                          name={`hpScheduleJsons[${index}].tuesday[${weekIndex}].markAsLeave`}
                                                          value={
                                                            hpScheduleJsons
                                                              .tuesday[
                                                              weekIndex
                                                            ]?.markAsLeave
                                                          }
                                                          size="small"
                                                          checked={Boolean(
                                                            hpScheduleJsons
                                                              ?.tuesday[
                                                              weekIndex
                                                            ]?.markAsLeave
                                                          )}
                                                        />
                                                      }
                                                      label="Mark as leave"
                                                      value={
                                                        hpScheduleJsons.tuesday[
                                                          weekIndex
                                                        ].markAsLeave
                                                      }
                                                      onChange={(
                                                        event: any,
                                                        newValue: any
                                                      ) => {
                                                        handleMarkAsLeave(
                                                          index,
                                                          "tuesday",
                                                          newValue
                                                        );
                                                      }}
                                                      onBlur={formik.handleBlur}
                                                    />
                                                  )}
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.5}
                                                >
                                                  <Stack
                                                    sx={{
                                                      flexDirection: "row",
                                                      justifyContent:
                                                        "flex-end",
                                                    }}
                                                  >
                                                    {weekIndex !== 0 && (
                                                      <Tooltip title="Delete">
                                                        <DeleteForeverOutlinedIcon
                                                          sx={{
                                                            marginTop: "5px",
                                                          }}
                                                          color="error"
                                                          onClick={() => {
                                                            if (
                                                              hpScheduleJsons
                                                                .tuesday[
                                                                weekIndex
                                                              ]?.panid !== "" &&
                                                              hpScheduleJsons
                                                                .tuesday[
                                                                weekIndex
                                                              ]?.panid !== "new"
                                                            ) {
                                                              handleDeleteDayData(
                                                                null,
                                                                hpScheduleJsons
                                                                  .tuesday[
                                                                  weekIndex
                                                                ]?.panid
                                                              );
                                                              arrayHelpers.form
                                                                .values
                                                                .hpScheduleJsons[
                                                                index
                                                              ].tuesday
                                                                .length !== 1
                                                                ? arrayHelpers.remove(
                                                                    weekIndex
                                                                  )
                                                                : arrayHelpers.remove(
                                                                    1
                                                                  );
                                                            } else {
                                                              arrayHelpers.form
                                                                .values
                                                                .hpScheduleJsons[
                                                                index
                                                              ].tuesday
                                                                .length !== 1
                                                                ? arrayHelpers.remove(
                                                                    weekIndex
                                                                  )
                                                                : arrayHelpers.remove(
                                                                    1
                                                                  );
                                                            }
                                                          }}
                                                        />
                                                      </Tooltip>
                                                    )}
                                                    <ButtonComponent
                                                      variant="contained"
                                                      size="small"
                                                      type="button"
                                                      buttonclass={
                                                        classes.saveButton
                                                      }
                                                      sx={{ minWidth: "20px" }}
                                                      onClick={() => {
                                                        if (
                                                          handleDaySave(
                                                            index,
                                                            "tuesday",
                                                            weekIndex
                                                          ) === false
                                                        ) {
                                                          handleSaveDayData(
                                                            index,
                                                            "tuesday",
                                                            formik,
                                                            weekIndex
                                                          );
                                                        } else {
                                                          setTouch(
                                                            index,
                                                            "tuesday"
                                                          );
                                                        }
                                                      }}
                                                      label="Save"
                                                    />
                                                  </Stack>
                                                </Grid>
                                              </Fragment>
                                            );
                                          }
                                        )}
                                        <Grid
                                          item
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          sx={{ marginTop: "20px" }}
                                        >
                                          {hpScheduleJsons.tuesday[0]?.panid !==
                                            "" &&
                                            hpScheduleJsons.tuesday[0]
                                              ?.panid !== undefined &&
                                            hpScheduleJsons.tuesday[0]
                                              ?.panid !== null && (
                                              <ButtonComponent
                                                buttonclass={
                                                  globalClasses.addButton
                                                }
                                                sx={{
                                                  maxWidth: "50px !importanat",
                                                  display:
                                                    arrayHelpers.form.values
                                                      .hpScheduleJsons[index]
                                                      .tuesday.length <= 1
                                                      ? "block"
                                                      : "none",
                                                }}
                                                variant="contained"
                                                label="Add"
                                                onClick={(e: any) => {
                                                  e.preventDefault();
                                                  arrayHelpers.form.values
                                                    .hpScheduleJsons[index]
                                                    .tuesday.length <= 1 &&
                                                    arrayHelpers.push({
                                                      padid: "new",
                                                      panid: "new",
                                                      noAppointments: "",
                                                      timingSlotDuration: "",
                                                      startTime: null,
                                                      endTime: null,
                                                      markAsLeave: false,
                                                    });
                                                }}
                                              />
                                            )}
                                        </Grid>
                                      </>
                                    )}
                                  />
                                </Grid>

                                <Grid
                                  container
                                  spacing={1}
                                  sx={{ marginBottom: "20px" }}
                                >
                                  <Grid item xs={12} sm={12} md={1.5}>
                                    {" "}
                                    <Typography sx={styles.dayText}>
                                      Wednesday
                                    </Typography>
                                  </Grid>
                                  <FieldArray
                                    name={`hpScheduleJsons[${index}].wednesday`}
                                    render={(arrayHelpers) => (
                                      <>
                                        {hpScheduleJsons.wednesday.map(
                                          (wednesday: any, weekIndex: any) => {
                                            return (
                                              <Fragment key={wednesday.dayId}>
                                                {weekIndex !== 0 && (
                                                  <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={1.5}
                                                  ></Grid>
                                                )}
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <input
                                                    type="hidden"
                                                    id={`hpScheduleJsons[${index}].wednesday[${weekIndex}].padid`}
                                                    name={`hpScheduleJsons[${index}].wednesday[${weekIndex}].padid`}
                                                    value={
                                                      hpScheduleJsons.wednesday[
                                                        weekIndex
                                                      ]?.padid ?? ""
                                                    }
                                                    onChange={
                                                      formik.handleChange
                                                    }
                                                    onBlur={formik.handleBlur}
                                                  />
                                                  <input
                                                    type="hidden"
                                                    id={`hpScheduleJsons[${index}].wednesday[${weekIndex}].panid`}
                                                    name={`hpScheduleJsons[${index}].wednesday[${weekIndex}].panid`}
                                                    value={
                                                      hpScheduleJsons.wednesday[
                                                        weekIndex
                                                      ]?.panid ?? ""
                                                    }
                                                    onChange={
                                                      formik.handleChange
                                                    }
                                                    onBlur={formik.handleBlur}
                                                  />
                                                  <InputField
                                                    id={`hpScheduleJsons[${index}].wednesday[${weekIndex}].noAppointments`}
                                                    name={`hpScheduleJsons[${index}].wednesday[${weekIndex}].noAppointments`}
                                                    label="No Of Appointments"
                                                    inputvalues={
                                                      hpScheduleJsons.wednesday[
                                                        weekIndex
                                                      ]?.noAppointments ?? ""
                                                    }
                                                    isrequired={true}
                                                    changeevent={(
                                                      event: any
                                                    ) => {
                                                      handleDayValueChange(
                                                        event,
                                                        index,
                                                        "wednesday"
                                                      );
                                                    }}
                                                    blurevent={
                                                      formik.handleBlur
                                                    }
                                                    errormessage={isError(
                                                      `hpScheduleJsons[${index}].wednesday[${weekIndex}].noAppointments`
                                                    )}
                                                    message={
                                                      <ErrorMessage
                                                        name={`hpScheduleJsons[${index}].wednesday[${weekIndex}].noAppointments`}
                                                      />
                                                    }
                                                  />
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <SelectField
                                                    id={`hpScheduleJsons[${index}].wednesday[${weekIndex}].timingSlotDuration`}
                                                    name={`hpScheduleJsons[${index}].wednesday[${weekIndex}].timingSlotDuration`}
                                                    headerText="Duration(min)"
                                                    label="Select Duration"
                                                    options={TIMINGSLOTDURATION}
                                                    isrequired={true}
                                                    value={
                                                      hpScheduleJsons.wednesday[
                                                        weekIndex
                                                      ]?.timingSlotDuration ??
                                                      ""
                                                    }
                                                    changeevent={(
                                                      event: any
                                                    ) => {
                                                      handleDayValueChange(
                                                        event,
                                                        index,
                                                        "wednesday"
                                                      );
                                                    }}
                                                    blurevent={
                                                      formik.handleBlur
                                                    }
                                                    error={isError(
                                                      `hpScheduleJsons[${index}].wednesday[${weekIndex}].timingSlotDuration`
                                                    )}
                                                  />
                                                  {isError(
                                                    `hpScheduleJsons[${index}].wednesday[${weekIndex}].timingSlotDuration`
                                                  ) && (
                                                    <Typography
                                                      sx={styles.errorMessage}
                                                    >
                                                      <ErrorMessage
                                                        name={`hpScheduleJsons[${index}].wednesday[${weekIndex}].timingSlotDuration`}
                                                      />
                                                    </Typography>
                                                  )}
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <TimeComponent
                                                    label="Start Time"
                                                    isrequired={true}
                                                    value={
                                                      hpScheduleJsons.wednesday[
                                                        weekIndex
                                                      ]?.startTime ?? null
                                                    }
                                                    onChange={(
                                                      newValue: any,
                                                      event: any
                                                    ) => {
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].wednesday[${weekIndex}].startTime`,
                                                        newValue
                                                      );
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].wednesday[${weekIndex}].markAsLeave`,
                                                        false
                                                      );
                                                    }}
                                                    error={
                                                      getIn(
                                                        formik.touched,
                                                        `hpScheduleJsons[${index}].wednesday[${weekIndex}].startTime`
                                                      ) &&
                                                      getIn(
                                                        formik.errors,
                                                        `hpScheduleJsons[${index}].wednesday[${weekIndex}].startTime`
                                                      )
                                                    }
                                                  />
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <TimeComponent
                                                    label="End Time"
                                                    isrequired={true}
                                                    value={
                                                      hpScheduleJsons.wednesday[
                                                        weekIndex
                                                      ]?.endTime ?? null
                                                    }
                                                    onChange={(
                                                      newValue: any
                                                    ) => {
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].wednesday[${weekIndex}].endTime`,
                                                        newValue
                                                      );
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].wednesday[${weekIndex}].markAsLeave`,
                                                        false
                                                      );
                                                    }}
                                                    error={
                                                      getIn(
                                                        formik.touched,
                                                        `hpScheduleJsons[${index}].wednesday[${weekIndex}].endTime`
                                                      ) &&
                                                      getIn(
                                                        formik.errors,
                                                        `hpScheduleJsons[${index}].wednesday[${weekIndex}].endTime`
                                                      )
                                                    }
                                                  />
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  {weekIndex === 0 && (
                                                    <FormControlLabel
                                                      className={
                                                        classes.setAsDefault
                                                      }
                                                      control={
                                                        <Checkbox
                                                          id={`hpScheduleJsons[${index}].wednesday[${weekIndex}].markAsLeave`}
                                                          name={`hpScheduleJsons[${index}].wednesday[${weekIndex}].markAsLeave`}
                                                          value={
                                                            hpScheduleJsons
                                                              .wednesday[
                                                              weekIndex
                                                            ]?.markAsLeave
                                                          }
                                                          size="small"
                                                          checked={Boolean(
                                                            hpScheduleJsons
                                                              ?.wednesday[
                                                              weekIndex
                                                            ]?.markAsLeave
                                                          )}
                                                        />
                                                      }
                                                      label="Mark as leave"
                                                      value={
                                                        hpScheduleJsons
                                                          .wednesday[weekIndex]
                                                          .markAsLeave
                                                      }
                                                      onChange={(
                                                        event: any,
                                                        newValue: any
                                                      ) => {
                                                        handleMarkAsLeave(
                                                          index,
                                                          "wednesday",
                                                          newValue
                                                        );
                                                      }}
                                                      onBlur={formik.handleBlur}
                                                    />
                                                  )}
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.5}
                                                >
                                                  <Stack
                                                    sx={{
                                                      flexDirection: "row",
                                                      justifyContent:
                                                        "flex-end",
                                                    }}
                                                  >
                                                    {weekIndex !== 0 && (
                                                      <Tooltip title="Delete">
                                                        <DeleteForeverOutlinedIcon
                                                          sx={{
                                                            marginTop: "5px",
                                                          }}
                                                          color="error"
                                                          onClick={() => {
                                                            if (
                                                              hpScheduleJsons
                                                                .wednesday[
                                                                weekIndex
                                                              ]?.panid !== "" &&
                                                              hpScheduleJsons
                                                                .wednesday[
                                                                weekIndex
                                                              ]?.panid !== "new"
                                                            ) {
                                                              handleDeleteDayData(
                                                                null,
                                                                hpScheduleJsons
                                                                  .wednesday[
                                                                  weekIndex
                                                                ]?.panid
                                                              );
                                                              arrayHelpers.form
                                                                .values
                                                                .hpScheduleJsons[
                                                                index
                                                              ].wednesday
                                                                .length !== 1
                                                                ? arrayHelpers.remove(
                                                                    weekIndex
                                                                  )
                                                                : arrayHelpers.remove(
                                                                    1
                                                                  );
                                                            } else {
                                                              arrayHelpers.form
                                                                .values
                                                                .hpScheduleJsons[
                                                                index
                                                              ].wednesday
                                                                .length !== 1
                                                                ? arrayHelpers.remove(
                                                                    weekIndex
                                                                  )
                                                                : arrayHelpers.remove(
                                                                    1
                                                                  );
                                                            }
                                                          }}
                                                        />
                                                      </Tooltip>
                                                    )}
                                                    <ButtonComponent
                                                      variant="contained"
                                                      size="small"
                                                      type="button"
                                                      buttonclass={
                                                        classes.saveButton
                                                      }
                                                      sx={{ minWidth: "20px" }}
                                                      onClick={() => {
                                                        if (
                                                          handleDaySave(
                                                            index,
                                                            "wednesday",
                                                            weekIndex
                                                          ) === false
                                                        ) {
                                                          handleSaveDayData(
                                                            index,
                                                            "wednesday",
                                                            formik,
                                                            weekIndex
                                                          );
                                                        } else {
                                                          setTouch(
                                                            index,
                                                            "wednesday"
                                                          );
                                                        }
                                                      }}
                                                      label="Save"
                                                    />
                                                  </Stack>
                                                </Grid>
                                              </Fragment>
                                            );
                                          }
                                        )}
                                        <Grid
                                          item
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          sx={{ marginTop: "20px" }}
                                        >
                                          {hpScheduleJsons.wednesday[0]
                                            ?.panid !== "" &&
                                            hpScheduleJsons.wednesday[0]
                                              ?.panid !== undefined &&
                                            hpScheduleJsons.wednesday[0]
                                              ?.panid !== null && (
                                              <ButtonComponent
                                                buttonclass={
                                                  globalClasses.addButton
                                                }
                                                sx={{
                                                  maxWidth: "50px !importanat",
                                                  display:
                                                    arrayHelpers.form.values
                                                      .hpScheduleJsons[index]
                                                      .wednesday.length <= 1
                                                      ? "block"
                                                      : "none",
                                                }}
                                                variant="contained"
                                                label="Add"
                                                onClick={(e: any) => {
                                                  e.preventDefault();
                                                  arrayHelpers.form.values
                                                    .hpScheduleJsons[index]
                                                    .wednesday.length <= 1 &&
                                                    arrayHelpers.push({
                                                      padid: "new",
                                                      panid: "new",
                                                      noAppointments: "",
                                                      timingSlotDuration: "",
                                                      startTime: null,
                                                      endTime: null,
                                                      markAsLeave: false,
                                                    });
                                                }}
                                              />
                                            )}
                                        </Grid>
                                      </>
                                    )}
                                  />
                                </Grid>

                                <Grid
                                  container
                                  spacing={1}
                                  sx={{ marginBottom: "20px" }}
                                >
                                  <Grid item xs={12} sm={12} md={1.5}>
                                    <Typography sx={styles.dayText}>
                                      Thursday
                                    </Typography>
                                  </Grid>
                                  <FieldArray
                                    name={`hpScheduleJsons[${index}].thursday`}
                                    render={(arrayHelpers) => (
                                      <>
                                        {hpScheduleJsons.thursday.map(
                                          (thursday: any, weekIndex: any) => {
                                            return (
                                              <Fragment key={thursday.dayId}>
                                                {weekIndex !== 0 && (
                                                  <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={1.5}
                                                  ></Grid>
                                                )}
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <input
                                                    type="hidden"
                                                    id={`hpScheduleJsons[${index}].thursday[${weekIndex}].padid`}
                                                    name={`hpScheduleJsons[${index}].thursday[${weekIndex}].padid`}
                                                    value={
                                                      hpScheduleJsons.thursday[
                                                        weekIndex
                                                      ]?.padid ?? ""
                                                    }
                                                    onChange={
                                                      formik.handleChange
                                                    }
                                                    onBlur={formik.handleBlur}
                                                  />
                                                  <input
                                                    type="hidden"
                                                    id={`hpScheduleJsons[${index}].thursday[${weekIndex}].panid`}
                                                    name={`hpScheduleJsons[${index}].thursday[${weekIndex}].panid`}
                                                    value={
                                                      hpScheduleJsons.thursday[
                                                        weekIndex
                                                      ]?.panid ?? ""
                                                    }
                                                    onChange={
                                                      formik.handleChange
                                                    }
                                                    onBlur={formik.handleBlur}
                                                  />
                                                  <InputField
                                                    id={`hpScheduleJsons[${index}].thursday[${weekIndex}].noAppointments`}
                                                    name={`hpScheduleJsons[${index}].thursday[${weekIndex}].noAppointments`}
                                                    label="No Of Appointments"
                                                    inputvalues={
                                                      hpScheduleJsons.thursday[
                                                        weekIndex
                                                      ]?.noAppointments ?? ""
                                                    }
                                                    isrequired={true}
                                                    changeevent={(
                                                      event: any
                                                    ) => {
                                                      handleDayValueChange(
                                                        event,
                                                        index,
                                                        "thursday"
                                                      );
                                                    }}
                                                    blurevent={
                                                      formik.handleBlur
                                                    }
                                                    errormessage={isError(
                                                      `hpScheduleJsons[${index}].thursday[${weekIndex}].noAppointments`
                                                    )}
                                                    message={
                                                      <ErrorMessage
                                                        name={`hpScheduleJsons[${index}].thursday[${weekIndex}].noAppointments`}
                                                      />
                                                    }
                                                  />
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <SelectField
                                                    id={`hpScheduleJsons[${index}].thursday[${weekIndex}].timingSlotDuration`}
                                                    name={`hpScheduleJsons[${index}].thursday[${weekIndex}].timingSlotDuration`}
                                                    headerText="Duration(min)"
                                                    label="Select Duration"
                                                    options={TIMINGSLOTDURATION}
                                                    isrequired={true}
                                                    value={
                                                      hpScheduleJsons.thursday[
                                                        weekIndex
                                                      ]?.timingSlotDuration ??
                                                      ""
                                                    }
                                                    changeevent={(
                                                      event: any
                                                    ) => {
                                                      handleDayValueChange(
                                                        event,
                                                        index,
                                                        "thursday"
                                                      );
                                                    }}
                                                    blurevent={
                                                      formik.handleBlur
                                                    }
                                                    error={isError(
                                                      `hpScheduleJsons[${index}].thursday[${weekIndex}].timingSlotDuration`
                                                    )}
                                                  />
                                                  {isError(
                                                    `hpScheduleJsons[${index}].thursday[${weekIndex}].timingSlotDuration`
                                                  ) && (
                                                    <Typography
                                                      sx={styles.errorMessage}
                                                    >
                                                      <ErrorMessage
                                                        name={`hpScheduleJsons[${index}].thursday[${weekIndex}].timingSlotDuration`}
                                                      />
                                                    </Typography>
                                                  )}
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <TimeComponent
                                                    label="Start Time"
                                                    isrequired={true}
                                                    value={
                                                      hpScheduleJsons.thursday[
                                                        weekIndex
                                                      ]?.startTime ?? null
                                                    }
                                                    onChange={(
                                                      newValue: any,
                                                      event: any
                                                    ) => {
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].thursday[${weekIndex}].startTime`,
                                                        newValue
                                                      );
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].thursday[${weekIndex}].markAsLeave`,
                                                        false
                                                      );
                                                    }}
                                                    error={
                                                      getIn(
                                                        formik.touched,
                                                        `hpScheduleJsons[${index}].thursday[${weekIndex}].startTime`
                                                      ) &&
                                                      getIn(
                                                        formik.errors,
                                                        `hpScheduleJsons[${index}].thursday[${weekIndex}].startTime`
                                                      )
                                                    }
                                                  />
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <TimeComponent
                                                    label="End Time"
                                                    isrequired={true}
                                                    value={
                                                      hpScheduleJsons.thursday[
                                                        weekIndex
                                                      ]?.endTime ?? null
                                                    }
                                                    onChange={(
                                                      newValue: any
                                                    ) => {
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].thursday[${weekIndex}].endTime`,
                                                        newValue
                                                      );
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].thursday[${weekIndex}].markAsLeave`,
                                                        false
                                                      );
                                                    }}
                                                    error={
                                                      getIn(
                                                        formik.touched,
                                                        `hpScheduleJsons[${index}].thursday[${weekIndex}].endTime`
                                                      ) &&
                                                      getIn(
                                                        formik.errors,
                                                        `hpScheduleJsons[${index}].thursday[${weekIndex}].endTime`
                                                      )
                                                    }
                                                  />
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  {weekIndex === 0 && (
                                                    <FormControlLabel
                                                      className={
                                                        classes.setAsDefault
                                                      }
                                                      control={
                                                        <Checkbox
                                                          id={`hpScheduleJsons[${index}].thursday[${weekIndex}].markAsLeave`}
                                                          name={`hpScheduleJsons[${index}].thursday[${weekIndex}].markAsLeave`}
                                                          value={
                                                            hpScheduleJsons
                                                              .thursday[
                                                              weekIndex
                                                            ]?.markAsLeave
                                                          }
                                                          size="small"
                                                          checked={Boolean(
                                                            hpScheduleJsons
                                                              ?.thursday[
                                                              weekIndex
                                                            ]?.markAsLeave
                                                          )}
                                                        />
                                                      }
                                                      label="Mark as leave"
                                                      value={
                                                        hpScheduleJsons
                                                          .thursday[weekIndex]
                                                          .markAsLeave
                                                      }
                                                      onChange={(
                                                        event: any,
                                                        newValue: any
                                                      ) => {
                                                        handleMarkAsLeave(
                                                          index,
                                                          "thursday",
                                                          newValue
                                                        );
                                                      }}
                                                      onBlur={formik.handleBlur}
                                                    />
                                                  )}
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.5}
                                                >
                                                  <Stack
                                                    sx={{
                                                      flexDirection: "row",
                                                      justifyContent:
                                                        "flex-end",
                                                    }}
                                                  >
                                                    {weekIndex !== 0 && (
                                                      <Tooltip title="Delete">
                                                        <DeleteForeverOutlinedIcon
                                                          sx={{
                                                            marginTop: "5px",
                                                          }}
                                                          color="error"
                                                          onClick={() => {
                                                            if (
                                                              hpScheduleJsons
                                                                .thursday[
                                                                weekIndex
                                                              ]?.panid !== "" &&
                                                              hpScheduleJsons
                                                                .thursday[
                                                                weekIndex
                                                              ]?.panid !== "new"
                                                            ) {
                                                              handleDeleteDayData(
                                                                null,
                                                                hpScheduleJsons
                                                                  .thursday[
                                                                  weekIndex
                                                                ]?.panid
                                                              );
                                                              arrayHelpers.form
                                                                .values
                                                                .hpScheduleJsons[
                                                                index
                                                              ].thursday
                                                                .length !== 1
                                                                ? arrayHelpers.remove(
                                                                    weekIndex
                                                                  )
                                                                : arrayHelpers.remove(
                                                                    1
                                                                  );
                                                            } else {
                                                              arrayHelpers.form
                                                                .values
                                                                .hpScheduleJsons[
                                                                index
                                                              ].thursday
                                                                .length !== 1
                                                                ? arrayHelpers.remove(
                                                                    weekIndex
                                                                  )
                                                                : arrayHelpers.remove(
                                                                    1
                                                                  );
                                                            }
                                                          }}
                                                        />
                                                      </Tooltip>
                                                    )}
                                                    <ButtonComponent
                                                      variant="contained"
                                                      size="small"
                                                      type="button"
                                                      buttonclass={
                                                        classes.saveButton
                                                      }
                                                      sx={{ minWidth: "20px" }}
                                                      onClick={() => {
                                                        if (
                                                          handleDaySave(
                                                            index,
                                                            "thursday",
                                                            weekIndex
                                                          ) === false
                                                        ) {
                                                          handleSaveDayData(
                                                            index,
                                                            "thursday",
                                                            formik,
                                                            weekIndex
                                                          );
                                                        } else {
                                                          setTouch(
                                                            index,
                                                            "thursday"
                                                          );
                                                        }
                                                      }}
                                                      label="Save"
                                                    />
                                                  </Stack>
                                                </Grid>
                                              </Fragment>
                                            );
                                          }
                                        )}
                                        <Grid
                                          item
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          sx={{ marginTop: "20px" }}
                                        >
                                          {hpScheduleJsons.thursday[0]
                                            ?.panid !== "" &&
                                            hpScheduleJsons.thursday[0]
                                              ?.panid !== undefined &&
                                            hpScheduleJsons.thursday[0]
                                              ?.panid !== null && (
                                              <ButtonComponent
                                                buttonclass={
                                                  globalClasses.addButton
                                                }
                                                sx={{
                                                  maxWidth: "50px !importanat",
                                                  display:
                                                    arrayHelpers.form.values
                                                      .hpScheduleJsons[index]
                                                      .thursday.length <= 1
                                                      ? "block"
                                                      : "none",
                                                }}
                                                variant="contained"
                                                label="Add"
                                                onClick={(e: any) => {
                                                  e.preventDefault();
                                                  arrayHelpers.form.values
                                                    .hpScheduleJsons[index]
                                                    .thursday.length <= 1 &&
                                                    arrayHelpers.push({
                                                      padid: "new",
                                                      panid: "new",
                                                      noAppointments: "",
                                                      timingSlotDuration: "",
                                                      startTime: null,
                                                      endTime: null,
                                                      markAsLeave: false,
                                                    });
                                                }}
                                              />
                                            )}
                                        </Grid>
                                      </>
                                    )}
                                  />
                                </Grid>

                                <Grid
                                  container
                                  spacing={1}
                                  sx={{ marginBottom: "20px" }}
                                >
                                  <Grid item xs={12} sm={12} md={1.5}>
                                    <Typography sx={styles.dayText}>
                                      Friday
                                    </Typography>
                                  </Grid>
                                  <FieldArray
                                    name={`hpScheduleJsons[${index}].friday`}
                                    render={(arrayHelpers) => (
                                      <>
                                        {hpScheduleJsons.friday.map(
                                          (friday: any, weekIndex: any) => {
                                            return (
                                              <Fragment key={friday.dayId}>
                                                {weekIndex !== 0 && (
                                                  <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={1.5}
                                                  ></Grid>
                                                )}
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <input
                                                    type="hidden"
                                                    id={`hpScheduleJsons[${index}].friday[${weekIndex}].padid`}
                                                    name={`hpScheduleJsons[${index}].friday[${weekIndex}].padid`}
                                                    value={
                                                      hpScheduleJsons.friday[
                                                        weekIndex
                                                      ]?.padid ?? ""
                                                    }
                                                    onChange={
                                                      formik.handleChange
                                                    }
                                                    onBlur={formik.handleBlur}
                                                  />
                                                  <input
                                                    type="hidden"
                                                    id={`hpScheduleJsons[${index}].friday[${weekIndex}].panid`}
                                                    name={`hpScheduleJsons[${index}].friday[${weekIndex}].panid`}
                                                    value={
                                                      hpScheduleJsons.friday[
                                                        weekIndex
                                                      ]?.panid ?? ""
                                                    }
                                                    onChange={
                                                      formik.handleChange
                                                    }
                                                    onBlur={formik.handleBlur}
                                                  />
                                                  <InputField
                                                    id={`hpScheduleJsons[${index}].friday[${weekIndex}].noAppointments`}
                                                    name={`hpScheduleJsons[${index}].friday[${weekIndex}].noAppointments`}
                                                    label="No Of Appointments"
                                                    inputvalues={
                                                      hpScheduleJsons.friday[
                                                        weekIndex
                                                      ]?.noAppointments ?? ""
                                                    }
                                                    isrequired={true}
                                                    changeevent={(
                                                      event: any
                                                    ) => {
                                                      handleDayValueChange(
                                                        event,
                                                        index,
                                                        "friday"
                                                      );
                                                    }}
                                                    blurevent={
                                                      formik.handleBlur
                                                    }
                                                    errormessage={isError(
                                                      `hpScheduleJsons[${index}].friday[${weekIndex}].noAppointments`
                                                    )}
                                                    message={
                                                      <ErrorMessage
                                                        name={`hpScheduleJsons[${index}].friday[${weekIndex}].noAppointments`}
                                                      />
                                                    }
                                                  />
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <SelectField
                                                    id={`hpScheduleJsons[${index}].friday[${weekIndex}].timingSlotDuration`}
                                                    name={`hpScheduleJsons[${index}].friday[${weekIndex}].timingSlotDuration`}
                                                    headerText="Duration(min)"
                                                    label="Select Duration"
                                                    options={TIMINGSLOTDURATION}
                                                    isrequired={true}
                                                    value={
                                                      hpScheduleJsons.friday[
                                                        weekIndex
                                                      ]?.timingSlotDuration ??
                                                      ""
                                                    }
                                                    changeevent={(
                                                      event: any
                                                    ) => {
                                                      handleDayValueChange(
                                                        event,
                                                        index,
                                                        "friday"
                                                      );
                                                    }}
                                                    blurevent={
                                                      formik.handleBlur
                                                    }
                                                    error={isError(
                                                      `hpScheduleJsons[${index}].friday[${weekIndex}].timingSlotDuration`
                                                    )}
                                                  />
                                                  {isError(
                                                    `hpScheduleJsons[${index}].friday[${weekIndex}].timingSlotDuration`
                                                  ) && (
                                                    <Typography
                                                      sx={styles.errorMessage}
                                                    >
                                                      <ErrorMessage
                                                        name={`hpScheduleJsons[${index}].friday[${weekIndex}].timingSlotDuration`}
                                                      />
                                                    </Typography>
                                                  )}
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <TimeComponent
                                                    label="Start Time"
                                                    isrequired={true}
                                                    value={
                                                      hpScheduleJsons.friday[
                                                        weekIndex
                                                      ]?.startTime ?? null
                                                    }
                                                    onChange={(
                                                      newValue: any,
                                                      event: any
                                                    ) => {
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].friday[${weekIndex}].startTime`,
                                                        newValue
                                                      );
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].friday[${weekIndex}].markAsLeave`,
                                                        false
                                                      );
                                                    }}
                                                    error={
                                                      getIn(
                                                        formik.touched,
                                                        `hpScheduleJsons[${index}].friday[${weekIndex}].startTime`
                                                      ) &&
                                                      getIn(
                                                        formik.errors,
                                                        `hpScheduleJsons[${index}].friday[${weekIndex}].startTime`
                                                      )
                                                    }
                                                  />
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <TimeComponent
                                                    label="End Time"
                                                    isrequired={true}
                                                    value={
                                                      hpScheduleJsons.friday[
                                                        weekIndex
                                                      ]?.endTime ?? null
                                                    }
                                                    onChange={(
                                                      newValue: any
                                                    ) => {
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].friday[${weekIndex}].endTime`,
                                                        newValue
                                                      );
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].friday[${weekIndex}].markAsLeave`,
                                                        false
                                                      );
                                                    }}
                                                    error={
                                                      getIn(
                                                        formik.touched,
                                                        `hpScheduleJsons[${index}].friday[${weekIndex}].endTime`
                                                      ) &&
                                                      getIn(
                                                        formik.errors,
                                                        `hpScheduleJsons[${index}].friday[${weekIndex}].endTime`
                                                      )
                                                    }
                                                  />
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  {weekIndex === 0 && (
                                                    <FormControlLabel
                                                      className={
                                                        classes.setAsDefault
                                                      }
                                                      control={
                                                        <Checkbox
                                                          id={`hpScheduleJsons[${index}].friday[${weekIndex}].markAsLeave`}
                                                          name={`hpScheduleJsons[${index}].friday[${weekIndex}].markAsLeave`}
                                                          value={
                                                            hpScheduleJsons
                                                              .friday[weekIndex]
                                                              ?.markAsLeave
                                                          }
                                                          size="small"
                                                          checked={Boolean(
                                                            hpScheduleJsons
                                                              ?.friday[
                                                              weekIndex
                                                            ]?.markAsLeave
                                                          )}
                                                        />
                                                      }
                                                      label="Mark as leave"
                                                      value={
                                                        hpScheduleJsons.friday[
                                                          weekIndex
                                                        ].markAsLeave
                                                      }
                                                      onChange={(
                                                        event: any,
                                                        newValue: any
                                                      ) => {
                                                        handleMarkAsLeave(
                                                          index,
                                                          "friday",
                                                          newValue
                                                        );
                                                      }}
                                                      onBlur={formik.handleBlur}
                                                    />
                                                  )}
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.5}
                                                >
                                                  <Stack
                                                    sx={{
                                                      flexDirection: "row",
                                                      justifyContent:
                                                        "flex-end",
                                                    }}
                                                  >
                                                    {weekIndex !== 0 && (
                                                      <Tooltip title="Delete">
                                                        <DeleteForeverOutlinedIcon
                                                          sx={{
                                                            marginTop: "5px",
                                                          }}
                                                          color="error"
                                                          onClick={() => {
                                                            if (
                                                              hpScheduleJsons
                                                                .friday[
                                                                weekIndex
                                                              ]?.panid !== "" &&
                                                              hpScheduleJsons
                                                                .friday[
                                                                weekIndex
                                                              ]?.panid !== "new"
                                                            ) {
                                                              handleDeleteDayData(
                                                                null,
                                                                hpScheduleJsons
                                                                  .friday[
                                                                  weekIndex
                                                                ]?.panid
                                                              );
                                                              arrayHelpers.form
                                                                .values
                                                                .hpScheduleJsons[
                                                                index
                                                              ].friday
                                                                .length !== 1
                                                                ? arrayHelpers.remove(
                                                                    weekIndex
                                                                  )
                                                                : arrayHelpers.remove(
                                                                    1
                                                                  );
                                                            } else {
                                                              arrayHelpers.form
                                                                .values
                                                                .hpScheduleJsons[
                                                                index
                                                              ].friday
                                                                .length !== 1
                                                                ? arrayHelpers.remove(
                                                                    weekIndex
                                                                  )
                                                                : arrayHelpers.remove(
                                                                    1
                                                                  );
                                                            }
                                                          }}
                                                        />
                                                      </Tooltip>
                                                    )}
                                                    <ButtonComponent
                                                      variant="contained"
                                                      size="small"
                                                      type="button"
                                                      buttonclass={
                                                        classes.saveButton
                                                      }
                                                      sx={{ minWidth: "20px" }}
                                                      onClick={() => {
                                                        if (
                                                          handleDaySave(
                                                            index,
                                                            "friday",
                                                            weekIndex
                                                          ) === false
                                                        ) {
                                                          handleSaveDayData(
                                                            index,
                                                            "friday",
                                                            formik,
                                                            weekIndex
                                                          );
                                                        } else {
                                                          setTouch(
                                                            index,
                                                            "friday"
                                                          );
                                                        }
                                                      }}
                                                      label="Save"
                                                    />
                                                  </Stack>
                                                </Grid>
                                              </Fragment>
                                            );
                                          }
                                        )}
                                        <Grid
                                          item
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          sx={{ marginTop: "20px" }}
                                        >
                                          {hpScheduleJsons.friday[0]?.panid !==
                                            "" &&
                                            hpScheduleJsons.friday[0]?.panid !==
                                              undefined &&
                                            hpScheduleJsons.friday[0]?.panid !==
                                              null && (
                                              <ButtonComponent
                                                buttonclass={
                                                  globalClasses.addButton
                                                }
                                                sx={{
                                                  maxWidth: "50px !importanat",
                                                  display:
                                                    arrayHelpers.form.values
                                                      .hpScheduleJsons[index]
                                                      .friday.length <= 1
                                                      ? "block"
                                                      : "none",
                                                }}
                                                variant="contained"
                                                label="Add"
                                                onClick={(e: any) => {
                                                  e.preventDefault();
                                                  arrayHelpers.form.values
                                                    .hpScheduleJsons[index]
                                                    .friday.length <= 1 &&
                                                    arrayHelpers.push({
                                                      padid: "new",
                                                      panid: "new",
                                                      noAppointments: "",
                                                      timingSlotDuration: "",
                                                      startTime: null,
                                                      endTime: null,
                                                      markAsLeave: false,
                                                    });
                                                }}
                                              />
                                            )}
                                        </Grid>
                                      </>
                                    )}
                                  />
                                </Grid>

                                <Grid
                                  container
                                  spacing={1}
                                  sx={{ marginBottom: "20px" }}
                                >
                                  <Grid item xs={12} sm={12} md={1.5}>
                                    {" "}
                                    <Typography sx={styles.dayText}>
                                      Saturday
                                    </Typography>
                                  </Grid>
                                  <FieldArray
                                    name={`hpScheduleJsons[${index}].saturday`}
                                    render={(arrayHelpers) => (
                                      <>
                                        {hpScheduleJsons.saturday.map(
                                          (saturday: any, weekIndex: any) => {
                                            return (
                                              <Fragment key={saturday.dayId}>
                                                {weekIndex !== 0 && (
                                                  <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={1.5}
                                                  ></Grid>
                                                )}
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <input
                                                    type="hidden"
                                                    id={`hpScheduleJsons[${index}].saturday[${weekIndex}].padid`}
                                                    name={`hpScheduleJsons[${index}].saturday[${weekIndex}].padid`}
                                                    value={
                                                      hpScheduleJsons.saturday[
                                                        weekIndex
                                                      ]?.padid ?? ""
                                                    }
                                                    onChange={
                                                      formik.handleChange
                                                    }
                                                    onBlur={formik.handleBlur}
                                                  />
                                                  <input
                                                    type="hidden"
                                                    id={`hpScheduleJsons[${index}].saturday[${weekIndex}].panid`}
                                                    name={`hpScheduleJsons[${index}].saturday[${weekIndex}].panid`}
                                                    value={
                                                      hpScheduleJsons.saturday[
                                                        weekIndex
                                                      ]?.panid ?? ""
                                                    }
                                                    onChange={
                                                      formik.handleChange
                                                    }
                                                    onBlur={formik.handleBlur}
                                                  />
                                                  <InputField
                                                    id={`hpScheduleJsons[${index}].saturday[${weekIndex}].noAppointments`}
                                                    name={`hpScheduleJsons[${index}].saturday[${weekIndex}].noAppointments`}
                                                    label="No Of Appointments"
                                                    inputvalues={
                                                      hpScheduleJsons.saturday[
                                                        weekIndex
                                                      ]?.noAppointments ?? ""
                                                    }
                                                    isrequired={true}
                                                    changeevent={(
                                                      event: any
                                                    ) => {
                                                      handleDayValueChange(
                                                        event,
                                                        index,
                                                        "saturday"
                                                      );
                                                    }}
                                                    blurevent={
                                                      formik.handleBlur
                                                    }
                                                    errormessage={isError(
                                                      `hpScheduleJsons[${index}].saturday[${weekIndex}].noAppointments`
                                                    )}
                                                    message={
                                                      <ErrorMessage
                                                        name={`hpScheduleJsons[${index}].saturday[${weekIndex}].noAppointments`}
                                                      />
                                                    }
                                                  />
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <SelectField
                                                    id={`hpScheduleJsons[${index}].saturday[${weekIndex}].timingSlotDuration`}
                                                    name={`hpScheduleJsons[${index}].saturday[${weekIndex}].timingSlotDuration`}
                                                    headerText="Duration(min)"
                                                    label="Select Duration"
                                                    options={TIMINGSLOTDURATION}
                                                    isrequired={true}
                                                    value={
                                                      hpScheduleJsons.saturday[
                                                        weekIndex
                                                      ]?.timingSlotDuration ??
                                                      ""
                                                    }
                                                    changeevent={(
                                                      event: any
                                                    ) => {
                                                      handleDayValueChange(
                                                        event,
                                                        index,
                                                        "saturday"
                                                      );
                                                    }}
                                                    blurevent={
                                                      formik.handleBlur
                                                    }
                                                    error={isError(
                                                      `hpScheduleJsons[${index}].saturday[${weekIndex}].timingSlotDuration`
                                                    )}
                                                  />
                                                  {isError(
                                                    `hpScheduleJsons[${index}].saturday[${weekIndex}].timingSlotDuration`
                                                  ) && (
                                                    <Typography
                                                      sx={styles.errorMessage}
                                                    >
                                                      <ErrorMessage
                                                        name={`hpScheduleJsons[${index}].saturday[${weekIndex}].timingSlotDuration`}
                                                      />
                                                    </Typography>
                                                  )}
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <TimeComponent
                                                    label="Start Time"
                                                    isrequired={true}
                                                    value={
                                                      hpScheduleJsons.saturday[
                                                        weekIndex
                                                      ]?.startTime ?? null
                                                    }
                                                    onChange={(
                                                      newValue: any,
                                                      event: any
                                                    ) => {
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].saturday[${weekIndex}].startTime`,
                                                        newValue
                                                      );
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].saturday[${weekIndex}].markAsLeave`,
                                                        false
                                                      );
                                                    }}
                                                    error={
                                                      getIn(
                                                        formik.touched,
                                                        `hpScheduleJsons[${index}].saturday[${weekIndex}].startTime`
                                                      ) &&
                                                      getIn(
                                                        formik.errors,
                                                        `hpScheduleJsons[${index}].saturday[${weekIndex}].startTime`
                                                      )
                                                    }
                                                  />
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <TimeComponent
                                                    label="End Time"
                                                    isrequired={true}
                                                    value={
                                                      hpScheduleJsons.saturday[
                                                        weekIndex
                                                      ]?.endTime ?? null
                                                    }
                                                    onChange={(
                                                      newValue: any
                                                    ) => {
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].saturday[${weekIndex}].endTime`,
                                                        newValue
                                                      );
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].saturday[${weekIndex}].markAsLeave`,
                                                        false
                                                      );
                                                    }}
                                                    error={
                                                      getIn(
                                                        formik.touched,
                                                        `hpScheduleJsons[${index}].saturday[${weekIndex}].endTime`
                                                      ) &&
                                                      getIn(
                                                        formik.errors,
                                                        `hpScheduleJsons[${index}].saturday[${weekIndex}].endTime`
                                                      )
                                                    }
                                                  />
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  {weekIndex === 0 && (
                                                    <FormControlLabel
                                                      className={
                                                        classes.setAsDefault
                                                      }
                                                      control={
                                                        <Checkbox
                                                          id={`hpScheduleJsons[${index}].saturday[${weekIndex}].markAsLeave`}
                                                          name={`hpScheduleJsons[${index}].saturday[${weekIndex}].markAsLeave`}
                                                          value={
                                                            hpScheduleJsons
                                                              .saturday[
                                                              weekIndex
                                                            ]?.markAsLeave
                                                          }
                                                          size="small"
                                                          checked={Boolean(
                                                            hpScheduleJsons
                                                              ?.saturday[
                                                              weekIndex
                                                            ]?.markAsLeave
                                                          )}
                                                        />
                                                      }
                                                      label="Mark as leave"
                                                      value={
                                                        hpScheduleJsons
                                                          .saturday[weekIndex]
                                                          .markAsLeave
                                                      }
                                                      onChange={(
                                                        event: any,
                                                        newValue: any
                                                      ) => {
                                                        handleMarkAsLeave(
                                                          index,
                                                          "saturday",
                                                          newValue
                                                        );
                                                      }}
                                                      onBlur={formik.handleBlur}
                                                    />
                                                  )}
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.5}
                                                >
                                                  <Stack
                                                    sx={{
                                                      flexDirection: "row",
                                                      justifyContent:
                                                        "flex-end",
                                                    }}
                                                  >
                                                    {weekIndex !== 0 && (
                                                      <Tooltip title="Delete">
                                                        <DeleteForeverOutlinedIcon
                                                          sx={{
                                                            marginTop: "5px",
                                                          }}
                                                          color="error"
                                                          onClick={() => {
                                                            if (
                                                              hpScheduleJsons
                                                                .saturday[
                                                                weekIndex
                                                              ]?.panid !== "" &&
                                                              hpScheduleJsons
                                                                .saturday[
                                                                weekIndex
                                                              ]?.panid !== "new"
                                                            ) {
                                                              handleDeleteDayData(
                                                                null,
                                                                hpScheduleJsons
                                                                  .saturday[
                                                                  weekIndex
                                                                ]?.panid
                                                              );
                                                              arrayHelpers.form
                                                                .values
                                                                .hpScheduleJsons[
                                                                index
                                                              ].saturday
                                                                .length !== 1
                                                                ? arrayHelpers.remove(
                                                                    weekIndex
                                                                  )
                                                                : arrayHelpers.remove(
                                                                    1
                                                                  );
                                                            } else {
                                                              arrayHelpers.form
                                                                .values
                                                                .hpScheduleJsons[
                                                                index
                                                              ].saturday
                                                                .length !== 1
                                                                ? arrayHelpers.remove(
                                                                    weekIndex
                                                                  )
                                                                : arrayHelpers.remove(
                                                                    1
                                                                  );
                                                            }
                                                          }}
                                                        />
                                                      </Tooltip>
                                                    )}
                                                    <ButtonComponent
                                                      variant="contained"
                                                      size="small"
                                                      type="button"
                                                      buttonclass={
                                                        classes.saveButton
                                                      }
                                                      sx={{ minWidth: "20px" }}
                                                      onClick={() => {
                                                        if (
                                                          handleDaySave(
                                                            index,
                                                            "saturday",
                                                            weekIndex
                                                          ) === false
                                                        ) {
                                                          handleSaveDayData(
                                                            index,
                                                            "saturday",
                                                            formik,
                                                            weekIndex
                                                          );
                                                        } else {
                                                          setTouch(
                                                            index,
                                                            "saturday"
                                                          );
                                                        }
                                                      }}
                                                      label="Save"
                                                    />
                                                  </Stack>
                                                </Grid>
                                              </Fragment>
                                            );
                                          }
                                        )}
                                        <Grid
                                          item
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          sx={{ marginTop: "20px" }}
                                        >
                                          {hpScheduleJsons.saturday[0]
                                            ?.panid !== "" &&
                                            hpScheduleJsons.saturday[0]
                                              ?.panid !== undefined &&
                                            hpScheduleJsons.saturday[0]
                                              ?.panid !== null && (
                                              <ButtonComponent
                                                buttonclass={
                                                  globalClasses.addButton
                                                }
                                                sx={{
                                                  maxWidth: "50px !importanat",
                                                  display:
                                                    arrayHelpers.form.values
                                                      .hpScheduleJsons[index]
                                                      .saturday.length <= 1
                                                      ? "block"
                                                      : "none",
                                                }}
                                                variant="contained"
                                                label="Add"
                                                onClick={(e: any) => {
                                                  e.preventDefault();
                                                  arrayHelpers.form.values
                                                    .hpScheduleJsons[index]
                                                    .saturday.length <= 1 &&
                                                    arrayHelpers.push({
                                                      padid: "new",
                                                      panid: "new",
                                                      noAppointments: "",
                                                      timingSlotDuration: "",
                                                      startTime: null,
                                                      endTime: null,
                                                      markAsLeave: false,
                                                    });
                                                }}
                                              />
                                            )}
                                        </Grid>
                                      </>
                                    )}
                                  />
                                </Grid>

                                <Grid
                                  container
                                  spacing={1}
                                  sx={{ marginBottom: "10px" }}
                                >
                                  <Grid item xs={12} sm={12} md={1.5}>
                                    <Typography sx={styles.dayText}>
                                      Sunday
                                    </Typography>
                                  </Grid>
                                  <FieldArray
                                    name={`hpScheduleJsons[${index}].sunday`}
                                    render={(arrayHelpers) => (
                                      <>
                                        {hpScheduleJsons.sunday.map(
                                          (sunday: any, weekIndex: any) => {
                                            return (
                                              <Fragment key={sunday.dayId}>
                                                {weekIndex !== 0 && (
                                                  <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={1.5}
                                                  ></Grid>
                                                )}
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <input
                                                    type="hidden"
                                                    id={`hpScheduleJsons[${index}].sunday[${weekIndex}].padid`}
                                                    name={`hpScheduleJsons[${index}].sunday[${weekIndex}].padid`}
                                                    value={
                                                      hpScheduleJsons.sunday[
                                                        weekIndex
                                                      ]?.padid ?? ""
                                                    }
                                                    onChange={
                                                      formik.handleChange
                                                    }
                                                    onBlur={formik.handleBlur}
                                                  />
                                                  <input
                                                    type="hidden"
                                                    id={`hpScheduleJsons[${index}].sunday[${weekIndex}].panid`}
                                                    name={`hpScheduleJsons[${index}].sunday[${weekIndex}].panid`}
                                                    value={
                                                      hpScheduleJsons.sunday[
                                                        weekIndex
                                                      ]?.panid ?? ""
                                                    }
                                                    onChange={
                                                      formik.handleChange
                                                    }
                                                    onBlur={formik.handleBlur}
                                                  />
                                                  <InputField
                                                    id={`hpScheduleJsons[${index}].sunday[${weekIndex}].noAppointments`}
                                                    name={`hpScheduleJsons[${index}].sunday[${weekIndex}].noAppointments`}
                                                    label="No Of Appointments"
                                                    inputvalues={
                                                      hpScheduleJsons.sunday[
                                                        weekIndex
                                                      ]?.noAppointments ?? ""
                                                    }
                                                    isrequired={true}
                                                    changeevent={(
                                                      event: any
                                                    ) => {
                                                      handleDayValueChange(
                                                        event,
                                                        index,
                                                        "sunday"
                                                      );
                                                    }}
                                                    blurevent={
                                                      formik.handleBlur
                                                    }
                                                    errormessage={isError(
                                                      `hpScheduleJsons[${index}].sunday[${weekIndex}].noAppointments`
                                                    )}
                                                    message={
                                                      <ErrorMessage
                                                        name={`hpScheduleJsons[${index}].sunday[${weekIndex}].noAppointments`}
                                                      />
                                                    }
                                                  />
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <SelectField
                                                    id={`hpScheduleJsons[${index}].sunday[${weekIndex}].timingSlotDuration`}
                                                    name={`hpScheduleJsons[${index}].sunday[${weekIndex}].timingSlotDuration`}
                                                    headerText="Duration(min)"
                                                    label="Select Duration"
                                                    options={TIMINGSLOTDURATION}
                                                    isrequired={true}
                                                    value={
                                                      hpScheduleJsons.sunday[
                                                        weekIndex
                                                      ]?.timingSlotDuration ??
                                                      ""
                                                    }
                                                    changeevent={(
                                                      event: any
                                                    ) => {
                                                      handleDayValueChange(
                                                        event,
                                                        index,
                                                        "sunday"
                                                      );
                                                    }}
                                                    blurevent={
                                                      formik.handleBlur
                                                    }
                                                    error={isError(
                                                      `hpScheduleJsons[${index}].sunday[${weekIndex}].timingSlotDuration`
                                                    )}
                                                  />
                                                  {isError(
                                                    `hpScheduleJsons[${index}].sunday[${weekIndex}].timingSlotDuration`
                                                  ) && (
                                                    <Typography
                                                      sx={styles.errorMessage}
                                                    >
                                                      <ErrorMessage
                                                        name={`hpScheduleJsons[${index}].sunday[${weekIndex}].timingSlotDuration`}
                                                      />
                                                    </Typography>
                                                  )}
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <TimeComponent
                                                    label="Start Time"
                                                    isrequired={true}
                                                    value={
                                                      hpScheduleJsons.sunday[
                                                        weekIndex
                                                      ]?.startTime ?? null
                                                    }
                                                    onChange={(
                                                      newValue: any,
                                                      event: any
                                                    ) => {
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].sunday[${weekIndex}].startTime`,
                                                        newValue
                                                      );
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].sunday[${weekIndex}].markAsLeave`,
                                                        false
                                                      );
                                                    }}
                                                    error={
                                                      getIn(
                                                        formik.touched,
                                                        `hpScheduleJsons[${index}].sunday[${weekIndex}].startTime`
                                                      ) &&
                                                      getIn(
                                                        formik.errors,
                                                        `hpScheduleJsons[${index}].sunday[${weekIndex}].startTime`
                                                      )
                                                    }
                                                  />
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  <TimeComponent
                                                    label="End Time"
                                                    isrequired={true}
                                                    value={
                                                      hpScheduleJsons.sunday[
                                                        weekIndex
                                                      ]?.endTime ?? null
                                                    }
                                                    onChange={(
                                                      newValue: any
                                                    ) => {
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].sunday[${weekIndex}].endTime`,
                                                        newValue
                                                      );
                                                      formik.setFieldValue(
                                                        `hpScheduleJsons[${index}].sunday[${weekIndex}].markAsLeave`,
                                                        false
                                                      );
                                                    }}
                                                    error={
                                                      getIn(
                                                        formik.touched,
                                                        `hpScheduleJsons[${index}].sunday[${weekIndex}].endTime`
                                                      ) &&
                                                      getIn(
                                                        formik.errors,
                                                        `hpScheduleJsons[${index}].sunday[${weekIndex}].endTime`
                                                      )
                                                    }
                                                  />
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.8}
                                                >
                                                  {weekIndex === 0 && (
                                                    <FormControlLabel
                                                      className={
                                                        classes.setAsDefault
                                                      }
                                                      control={
                                                        <Checkbox
                                                          id={`hpScheduleJsons[${index}].sunday[${weekIndex}].markAsLeave`}
                                                          name={`hpScheduleJsons[${index}].sunday[${weekIndex}].markAsLeave`}
                                                          value={
                                                            hpScheduleJsons
                                                              .sunday[weekIndex]
                                                              ?.markAsLeave
                                                          }
                                                          size="small"
                                                          checked={Boolean(
                                                            hpScheduleJsons
                                                              ?.sunday[
                                                              weekIndex
                                                            ]?.markAsLeave
                                                          )}
                                                        />
                                                      }
                                                      label="Mark as leave"
                                                      value={
                                                        hpScheduleJsons.sunday[
                                                          weekIndex
                                                        ].markAsLeave
                                                      }
                                                      onChange={(
                                                        event: any,
                                                        newValue: any
                                                      ) => {
                                                        handleMarkAsLeave(
                                                          index,
                                                          "sunday",
                                                          newValue
                                                        );
                                                      }}
                                                      onBlur={formik.handleBlur}
                                                    />
                                                  )}
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  md={1.5}
                                                >
                                                  <Stack
                                                    sx={{
                                                      flexDirection: "row",
                                                      justifyContent:
                                                        "flex-end",
                                                    }}
                                                  >
                                                    {weekIndex !== 0 && (
                                                      <Tooltip title="Delete">
                                                        <DeleteForeverOutlinedIcon
                                                          sx={{
                                                            marginTop: "5px",
                                                          }}
                                                          color="error"
                                                          onClick={() => {
                                                            if (
                                                              hpScheduleJsons
                                                                .sunday[
                                                                weekIndex
                                                              ]?.panid !== "" &&
                                                              hpScheduleJsons
                                                                .sunday[
                                                                weekIndex
                                                              ]?.panid !== "new"
                                                            ) {
                                                              handleDeleteDayData(
                                                                null,
                                                                hpScheduleJsons
                                                                  .sunday[
                                                                  weekIndex
                                                                ]?.panid
                                                              );
                                                              arrayHelpers.form
                                                                .values
                                                                .hpScheduleJsons[
                                                                index
                                                              ].sunday
                                                                .length !== 1
                                                                ? arrayHelpers.remove(
                                                                    weekIndex
                                                                  )
                                                                : arrayHelpers.remove(
                                                                    1
                                                                  );
                                                            } else {
                                                              arrayHelpers.form
                                                                .values
                                                                .hpScheduleJsons[
                                                                index
                                                              ].sunday
                                                                .length !== 1
                                                                ? arrayHelpers.remove(
                                                                    weekIndex
                                                                  )
                                                                : arrayHelpers.remove(
                                                                    1
                                                                  );
                                                            }
                                                          }}
                                                        />
                                                      </Tooltip>
                                                    )}
                                                    <ButtonComponent
                                                      variant="contained"
                                                      size="small"
                                                      type="button"
                                                      buttonclass={
                                                        classes.saveButton
                                                      }
                                                      sx={{ minWidth: "20px" }}
                                                      onClick={() => {
                                                        if (
                                                          handleDaySave(
                                                            index,
                                                            "sunday",
                                                            weekIndex
                                                          ) === false
                                                        ) {
                                                          handleSaveDayData(
                                                            index,
                                                            "sunday",
                                                            formik,
                                                            weekIndex
                                                          );
                                                        } else {
                                                          setTouch(
                                                            index,
                                                            "sunday"
                                                          );
                                                        }
                                                      }}
                                                      label="Save"
                                                    />
                                                  </Stack>
                                                </Grid>
                                              </Fragment>
                                            );
                                          }
                                        )}
                                        <Grid
                                          item
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          sx={{ marginTop: "20px" }}
                                        >
                                          {hpScheduleJsons.sunday[0]?.panid !==
                                            "" &&
                                            hpScheduleJsons.sunday[0]?.panid !==
                                              undefined &&
                                            hpScheduleJsons.sunday[0]?.panid !==
                                              null && (
                                              <ButtonComponent
                                                buttonclass={
                                                  globalClasses.addButton
                                                }
                                                sx={{
                                                  maxWidth: "50px !importanat",
                                                  display:
                                                    arrayHelpers.form.values
                                                      .hpScheduleJsons[index]
                                                      .sunday.length <= 1
                                                      ? "block"
                                                      : "none",
                                                }}
                                                variant="contained"
                                                label="Add"
                                                onClick={(e: any) => {
                                                  e.preventDefault();
                                                  arrayHelpers.form.values
                                                    .hpScheduleJsons[index]
                                                    .sunday.length <= 1 &&
                                                    arrayHelpers.push({
                                                      padid: "new",
                                                      panid: "new",
                                                      noAppointments: "",
                                                      timingSlotDuration: "",
                                                      startTime: null,
                                                      endTime: null,
                                                      markAsLeave: false,
                                                    });
                                                }}
                                              />
                                            )}
                                        </Grid>
                                      </>
                                    )}
                                  />
                                </Grid>
                              </Collapse>
                            </Grid>
                          </Grid>
                        )
                      )}
                      <Grid
                        item
                        xs={12}
                        md={12}
                        sx={{
                          marginTop: "40px !important",
                          padding: "10px",
                        }}
                      >
                        <ButtonComponent
                          buttonclass={globalClasses.addButton}
                          variant="contained"
                          size="small"
                          label="Add Another"
                          onClick={() => {
                            arrayHelpers.push({
                              padid: "new",
                              clinicTypeId: "new",
                              clinicLocationsId: "new",
                              clinicType: "",
                              clinicLocations: "",
                              noAppointments: "",
                              timingSlotDuration: "",
                              startTime: "",
                              endTime: "",
                              setAsDefault: "",
                              monday: [
                                {
                                  padid: "new",
                                  panid: "new",
                                  noAppointments: "",
                                  timingSlotDuration: "",
                                  startTime: "",
                                  endTime: "",
                                  markAsLeave: "",
                                },
                              ],
                              tuesday: [
                                {
                                  padid: "new",
                                  panid: "new",
                                  noAppointments: "",
                                  timingSlotDuration: "",
                                  startTime: "",
                                  endTime: "",
                                  markAsLeave: "",
                                },
                              ],
                              wednesday: [
                                {
                                  padid: "new",
                                  panid: "new",
                                  noAppointments: "",
                                  timingSlotDuration: "",
                                  startTime: "",
                                  endTime: "",
                                  markAsLeave: "",
                                },
                              ],
                              thursday: [
                                {
                                  padid: "new",
                                  panid: "new",
                                  noAppointments: "",
                                  timingSlotDuration: "",
                                  startTime: "",
                                  endTime: "",
                                  markAsLeave: "",
                                },
                              ],
                              friday: [
                                {
                                  padid: "new",
                                  panid: "new",
                                  noAppointments: "",
                                  timingSlotDuration: "",
                                  startTime: "",
                                  endTime: "",
                                  markAsLeave: "",
                                },
                              ],
                              saturday: [
                                {
                                  padid: "new",
                                  panid: "new",
                                  noAppointments: "",
                                  timingSlotDuration: "",
                                  startTime: "",
                                  endTime: "",
                                  markAsLeave: "",
                                },
                              ],
                              sunday: [
                                {
                                  padid: "new",
                                  panid: "new",
                                  noAppointments: "",
                                  timingSlotDuration: "",
                                  startTime: "",
                                  endTime: "",
                                  markAsLeave: "",
                                },
                              ],
                            });
                          }}
                        />
                      </Grid>
                    </Box>
                  )}
                />
              </Grid>
            </FormikProvider>
          )}
        </Grid>
      </CommonCard>
    </CommonLayout>
  );
};

export default HPWeeklyTimingTabs;

const styles = {
  errorMessage: {
    fontSize: "12px",
    padding: "5px",
    color: "#d32f2f",
  },
  dayText: {
    fontSize: "1rem",
    color: "#1b99d6",
    fontWeight: 500,
  },
  backdrop: {
    color: "#fff",
    zIndex: 1500,
    display: "flex",
    flexDirection: "column",
  },
};
